import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, forkJoin, Observable, of, Subscription } from "rxjs";
import { Message } from "src/app/core/class/message";
import { ErrorCode } from "src/app/core/constants/error-code";
import { SCREEN_SIZE } from "src/app/core/constants/screen-size";
import { CommonService } from "src/app/core/services/common.service";
import { CertificateTypeID, Common } from "src/app/core/constants/common";
import { DigitalCertificateService } from "src/app/core/services/digital-certificate.service";
import { DocumentService } from "src/app/core/services/document.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { ResponsiveService } from "src/app/core/services/responsive.service";
import { SignDocumentService } from "src/app/core/services/sign-document.service";
import { BreadcrumbsService } from "src/app/shared/components/breadcrumbs/breadcrumbs.service";
import { AddDigitalCertificateComponent } from "../../digital-certificate/add-digital-certificate/add-digital-certificate.component";
import { EnumSignMethod } from "src/app/core/constants/contract";
import * as htmlToImage from "html-to-image";
import { EnterpriseTypes } from "src/app/core/constants/enterprise-type";
import { AlertComponent } from "src/app/shared/components/alert/alert.component";
import { DomSanitizer } from "@angular/platform-browser";
// @ts-ignore
import { NzUploadFile } from "ng-zorro-antd/upload";
import { CanvasService } from "src/app/core/services/canvas.service";
import {
  ContentPosition,
  SignatureConfig,
} from "../sign-flow-document/signature-config.model";
import { map, switchMap, tap } from "rxjs/operators";
import {
  imageConfigFormPreviewId,
  imageConfigRenderId,
  imageConfigViewScaleId,
  ImageSignConfigComponent,
  transformContentPositionValue
} from '../sign-flow-document/image-sign-config/image-sign-config.component';
import { SignPositionTypes } from 'src/app/core/constants/signposition-types';
import { TranslateService } from '@ngx-translate/core';
import { EnvService } from 'src/app/core/services/env.service';
import { format } from 'date-fns';
import { SignDocumentComponent } from '../sign-document/sign-document.component';
import { CanvasComponent } from 'src/app/shared/components/canvas/canvas.component';
import FileUtils from 'src/app/core/services/file-utils';
import { ConfirmResignEkycSupportComponent } from '../confirm-resign-ekyc-support/confirm-resign-ekyc-support.component';
import { EkycCameraComponent } from '../ekyc/ekyc-camera/ekyc-camera.component';
import { NotifyWarningComponent } from 'src/app/shared/components/notify-warning/notify-warning.component';
import { SigningDialogComponent } from '../signing-dialog/signing-dialog.component';
import * as _ from 'lodash';
import { ConfirmSignOtpWithImageComponent } from '../confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
import { FormControl } from '@angular/forms';
import { ApiService } from 'src/app/core/services/api.service';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UsbTokenService } from 'src/app/core/services/usb-token.service';
import {ImageGenerateService} from "../../../../../../core/services/image-generate.service";
import { SaveSessionCloudCaDialogApproveComponent } from './save-session-cloud-ca-dialog/save-session-cloud-ca-dialog.component';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';

// declare Plugin

declare var $: any;

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginSign(comp): any;

declare function getSessionId(): any;

declare function initPluginCertificateNormal(comp: any, contracts: any): any;

declare function anonymousSignHash(
  comp,
  hashBase64,
  sessionId,
  serialNumber
): any;

declare function signHashNormal(comp, hashBase64, sessionId, serialNumber): any;

declare function normalSignHash(comp, hashBase64, sessionId, serialNumber): any;

declare function checkPlugin(comp): any;

export interface SelectedCertInterface {
  serialNumber: string;
  phoneNumber: any;
  typeCertificate: any;
  id: any;
  idDetail: any;
  imageUrl: any;
  issuedTo: string;
  taxCode: string;
  [key: string]: any;
}

@Component({
  selector: "app-sign-flow-document-approve",
  templateUrl: "./sign-flow-document-approve.component.html",
  styleUrls: ["./sign-flow-document-approve.component.scss"],
})
export class SignFlowDocumentApproveComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  // START DECLARE VARIABLE
  @BlockUI() blockUI: NgBlockUI;
  language: string;
  public isCancelSign = false;

  // variable layout
  isCheckAccessToContract: boolean = true;
  isFullviewPdf: boolean = false;
  subcribeViewLandscape: Subscription;
  isViewLandscape: boolean = false;
  BASE_URL: string = "";

  // variable breakpoint
  mediaBreakpoint: any;
  subscribeMediaBreakPointService: Subscription;

  // variable dialog
  dialogRef: any;

  // variable contract
  document: any;
  contractId: string = "";
  enterpriseId: string = "";
  fileUpload: File;
  scopeType: number = 0;

  // variable router
  routeLink: string = "";
  DEFAULT_ROUTER_ON_BACK_LINK = "/home-enterprise/search-document/";
  DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK =
    "/home-enterprise/search-document-receive/";
  SIGN_WAIT_ROUTER_ON_BACK_LINK = "/home-enterprise/search-document-sign";
  APPOVAL_WAIT_ROUTER_ON_BACK_LINK =
    "/home-enterprise/search-approval-waiting-document";
  INITIAL_WAIT_ROUTER_ON_BACK_LINK =
    "/home-enterprise/search-initial-waiting-document";
  MY_DOCUMENT_ROUTER_ON_BACK_LINK =
    "/home-enterprise/search-my-created-document";
  DOCUMENT_MOHA_LINK =
    "/home-enterprise/new-document-moha";
  DOCUMENT_DIGITAL_LINK =
    "/home-enterprise/digital-contract-employment";
  SIGN_WAIT_ROUTER_ON_BACK_LINK_MOHA = '/home-enterprise/approved-contract-moha';
  // variable pre page
  goFrom: string = "";
  signPage: string = "";
  page: string = "";
  pageSize: string = "";
  enterprise: string = "";
  documentTypeSearch: string = "";
  nameOrCode: string = "";
  status: string = "";
  serviceType: string = "";
  taxCode: string = "";
  createdUser: string = "";
  createdTimeFrom: string = "";
  createdTimeTo: string = "";
  finishDateFrom: string = "";
  finishDateTo: string = "";
  sortColumn: string = "";
  sortDirection: string = "";
  customerName: string = "";

  // variable permission
  permissions: any[];
  isHasPermissionAddCert: boolean = false;
  isHsmPermission: boolean = false;
  isNotAttestedUser: boolean = false;

  // variable EKYC
  @ViewChild(EkycCameraComponent, { static: false }) ekyc;
  supportEkyc: boolean = false;
  isShowEKYC: boolean = false;
  ekycSupportConfig: number = null;
  isStillQuantityEkyc: boolean = false;
  isQuantityEkyc: boolean = false;
  isQuantityAdvancedEkyc: boolean = false;
  enterpriseInfo: any;
  isPassport: boolean = false;
  templateRefEKYC: TemplateRef<any>;
  isShowWebcam: boolean = false;
  triedFallback: boolean = false;
  // variable sign method
  subscribeHash: BehaviorSubject<string>;
  sessionId: string;

  //agree checkbox
  isAgree: boolean = false;
  disableAgree: boolean = true;
  displayCheckbox: boolean = false;

  private linkDownSignPlugin(os?: string) {
    let OSName = os;
    if (typeof os === "undefined") {
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";
    }
    return (
      this.apiService.getBaseUrl() +
      `/file/download-last-version?os=${OSName}&typeFile=${
        OSName === "WINDOWS" ? "exe" : OSName === "LINUX" ? "deb" : "pkg"
      }`
    );
  }
  isHaveDataSignMethodHSM: boolean = false;
  isHaveDataSignMethodUSB: boolean = false;
  isHaveDataSignMethodSIM_CA: boolean = false;
  isHaveDataSignMethodCLOUD_CA: boolean = false;
  isHaveDataSignMethodEASY_CA: boolean = false;
  isHaveDataSignMethodOTP: boolean = false;
  isHaveDataSignMethodVNEID: boolean = false;
  allowOtp: boolean = false;
  allowImage: boolean = false;
  checkCertNumber: boolean = false;
  isEmploymentContract: boolean = false;
  checkName: boolean = false;
  checkOtp: boolean = false;
  checkEasyCa: boolean = false;
  checkVNeID: boolean = false;
  imageCertificates: any[] = [];
  certificates: any[] = [];
  typeCertificate: number = 0;
  userType = localStorage.getItem('userType')
  VNeIDTransactionCode: any = null;
  isCertificateDefault: boolean = false;
  isCertificateSupport: boolean = false;
  openMethodSign: boolean = false;
  selectedCert: SelectedCertInterface = {
    serialNumber: "",
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: "",
    taxCode: "",
  };
  columnsToDisplay: string[] = [];
  columnDefinitions = [
    {
      def: "radioBtn",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];
  columnsToDisplayOTP: string[] = [];
  columnDefinitionsOTP = [
    {
      def: "radioBtn",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];

  columnsToDisplayCloudCA: string[] = [];
  columnDefinitionsCloudCA = [
    {
      def: "radioBtn",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "hasTransSaved",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];
  columnsToDisplayEasyCA: string[] = [];
  columnDefinitionsEasyCA = [
    {
      def: "radioBtn",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "pin",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "isSavePin",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];
  columnsToDisplayVNeID: string[] = [];
  columnDefinitionsVNeID = [
    {
      def: "radioBtn",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "issuedBy",
      showXS: false,
      showSM: false,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "issuedTo",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "mstCccdTkSdt",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
    {
      def: "expireDate",
      showXS: true,
      showSM: true,
      showMD: true,
      showLG: true,
      showXL: true,
    },
  ];
  enumSignMethod = EnumSignMethod;
  certificateTypeID = CertificateTypeID;

  // variable signImage and Canvas
  // @ts-ignore
  @ViewChild(ImageSignConfigComponent)
  imageSignConfig: ImageSignConfigComponent;
  // @ts-ignore
  @ViewChild("SignImageConfig", { static: true }) domRenderImage: ElementRef;
  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;
  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  enterpriseName: string = "";
  beforeUpload = this.commonService.beforeUploadImage;
  loading: boolean;
  avatarUrl: string = "";
  signConfig: SignatureConfig = SignatureConfig.build();
  systemImageSign: boolean = false; // Biến này check có dùng chân ký mặc định k
  isSelectDrawImage: boolean = false;
  isUploadImage: boolean = false;
  dateNow = format(new Date(), 'DD/MM/YYYY');
  indexSelect: number = 0;
  imageUrlPreview: any;
  validateCertificateSign: any = {
    certificateNo: "",
    representDocumentNumber: "",
    taxCode: "",
  };

  signatureImageUpload: string = "";
  signatureImageDraw: string = "";
  signatureImageDefault: string = "";
  signatureFileDefault: any;
  certificateLastest: any;
  customerImagesConfig: string[] = [];

  // variable userSign Or enterpriseSign
  isSignDigitalCertificate: boolean = false;
  roleApprover: string = "";

  // variable PDF
  textLayerDiv: any;
  zoomLevel: number = 100;
  isShowSidebarButton = true;
  isAllowSelectSignPosition: boolean = true; // Biến này để check xem đang trong luồng đặt chân ký k
  isSelectedPosition = new BehaviorSubject<boolean>(true); // Biến này để check xem đã đặt chân ký hay chưa
  activeFile: number = 0;
  pdfSrc: any;
  pageCurrent: number = 1;
  authorization: any;
  fileError: string[] = [];
  listPdfSrc: any;
  pageIndex: number = 0;
  stampWrapper: HTMLDivElement;
  widthImageRender: number = 0;
  heightImageRender: number = 0;
  widthRectangle: number = 300; // width khung ký
  heightRectangle: number = 136; // height khung ký
  imagePreviewWidth: number = 0;
  imagePreviewHeight: number = 0;
  isGotoSignpage: boolean = true;
  isPersonalCustomer = false;
  isShowPdf: boolean = false;

  // variable Sign
  canMoveAndResize: boolean = false;
  isShowImage: boolean = true;
  isCustomer: boolean = false;
  onlyDigital: boolean = false;
  signPosition: any[];
  signPositionTypes = SignPositionTypes;
  imageData: any = [];
  signImages: any = [];
  saveImageData: any = [];
  sign: any;
  signProcessing: any[] = [];
  signTransactionId: any;
  errorStatus: string;
  signError: string = null;
  isCancel: boolean = false;
  isCallDone: boolean = false;
  processingId: string = null;
  userCancel: boolean = false;
  success: boolean;
  signingInteval: any;
  openSigningDialog: boolean = false;
  noteControl = new FormControl("");


  // variable button
  @ViewChild("navigation", { static: false }) navigation: ElementRef;
  isDisableSignBtn: boolean = true;

  customerMohaId: any = null;
  creatorSide : boolean = false;

  // END DECLARE VARIABLE

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private dialog: MatDialog,
    private commonService: CommonService,
    private activeRoute: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    private documentService: DocumentService,
    private digitalCertificateService: DigitalCertificateService,
    public message: Message,
    private toastr: ToastrService,
    private signDocumentService: SignDocumentService,
    private responsiveService: ResponsiveService,
    private sanitizer: DomSanitizer,
    private canvasService: CanvasService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private env: EnvService,
    private renderer: Renderer2,
    private apiService: ApiService,
    private enterpriseService: EnterpriseService,
    private usbTokenService: UsbTokenService,
    public deviceService: DeviceDetectorService,
    private imageGenerateService: ImageGenerateService,
    private route: ActivatedRoute,
    private documentMohaService: DocumentMohaService
  ) {
    this.language = localStorage.getItem("__language") || "vi";
    this.enterpriseId = localStorage.getItem("enterpriseId");
    this.enterpriseName = localStorage.getItem("fullName");
    this.permissions = localStorage
      .getItem("permissions")
      .match(/\d+/g)
      .map(Number);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.subscribeHash = new BehaviorSubject<string>("");
    this.BASE_URL = env.is_private_app
      ? env.private_api_endpoint
      : env.public_api_endpoint;
    this.BASE_URL += "/file/view/contract";
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    };
  }

  async ngOnInit() {
    this.initData();
    this.documentService.getApparamInfo({code: 'enable_sign_vneid'}).subscribe(res => {
      if(res.data){
        this.checkVNeID = JSON.parse(res.data.value) && res.data.status;
      }
    });
    
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService
      ._getMediaBreakpoint()
      .subscribe((media) => {
        if (media === "") {
          this.mediaBreakpoint = "";
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
          this.getDisplayedColumnsOTP();
          this.getDisplayedColumnsCloudCA();
          this.getDisplayedColumnsEasyCA();
          this.getDisplayedColumnsVNeID();
          switch (this.mediaBreakpoint) {
            case SCREEN_SIZE.XS:
              this.canvasWidth = 320;
              this.canvasHeight = Math.round(320 * (136 / 300));
              break;
            case SCREEN_SIZE.SM:
              this.canvasWidth = 345;
              this.canvasHeight = Math.round(345 * (136 / 300));
              break;
            case SCREEN_SIZE.MD:
              this.canvasWidth = 450;
              break;
            case SCREEN_SIZE.XL:
              this.canvasWidth = 470;
              break;
            default:
              this.canvasWidth = 660;
              break;
          }
        }
      });

    this.subcribeViewLandscape = this.responsiveService
      .getView()
      .subscribe((isLandscape) => {
        this.isViewLandscape = isLandscape;
      });
    this.getDocumentById(this.contractId);
    //this.nzSelectChange(0);
  }

  // --------------------- START FUNCTION --------------------------

  // fn InitData
  initData() {
    this.checkAccessContract();
    this.setLanguage();
    this.processRouteAndBreadcrumbs();
    this.loadDataContract();
  }

  loadDataContract() {
    this.contractId = this.activeRoute.snapshot.paramMap.get("id");

    this.signDocumentService.openSigningDialog.subscribe((rs) => {
      this.openSigningDialog = rs;
    });

    this.isSelectedPosition.subscribe((value) => {
      if (
        (this.isSignDigitalCertificate && this.isShowImage) ||
        !this.isSignDigitalCertificate
      ) {
        this.isDisableSignBtn = value;
      } else {
        this.isDisableSignBtn = false;
      }
    });

    // file pdf lấy từ màn xem chi tiết
    this.documentService.contractFilesInfo.subscribe((info) => {
      this.listPdfSrc = info;
    });

    this.canvasService.canvasSignatureImage.subscribe((imgUpload) => {
      if (imgUpload) {
        this.fileUpload = imgUpload;
      }
    });

    this.canvasService.canvasSignatureImageUrl.subscribe((imgUrl) => {
      this.imageUrlPreview = imgUrl;
      this.signatureImageDraw = imgUrl;
      const img = new Image();
      img.src = this.imageUrlPreview;
      img.onload = () => {
        this.widthImageRender = img.width;
        this.heightImageRender = img.height;
      };
      setTimeout(() => {
        this.reRenderSignature();
      }, 100);
    });

    this.documentService
      .getImageSignature()
      .subscribe((imageSignature: any) => {
        this.blockUI.start("");
        if (imageSignature && imageSignature.url) {
          this.imageUrlPreview = imageSignature.url;
          const img = new Image();
          img.src = this.imageUrlPreview;
          img.onload = () => {
            this.widthImageRender = img.width;
            this.heightImageRender = img.height;
          };
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }

        if (imageSignature && imageSignature.fileUpload) {
          this.fileUpload = imageSignature.fileUpload;
        }
        setTimeout(() => {
          this.blockUI.stop();
        }, 500);
      });

    this.getEnterprise();
    const userId = localStorage.getItem("userId");
    if (userId) {
      this.documentService
        .getListEnterpriseUserSignBydocumentIdService(this.contractId)
        .subscribe((res) => {
          const userSign = res.data.userSign;
          const approverFilter = userSign.find((rs) => rs.userId === userId);
          if (approverFilter) {
            this.roleApprover = approverFilter.role;
            this.isSignDigitalCertificate =
              approverFilter.isSignDigitalCertificate;
            this.isCustomer = !approverFilter.isCreatedSide;
            this.loadConfigAndCertificates(approverFilter.role);
            if (
              approverFilter.signConfig &&
              JSON.parse(approverFilter.signConfig)
            ) {
              this.canMoveAndResize = approverFilter.signConfig
                ? JSON.parse(approverFilter.signConfig).resize
                : false;
              this.isShowImage = approverFilter.signConfig
                ? this.setDataSignConfig(JSON.parse(approverFilter.signConfig))
                    .showImage
                : {
                    resize: false,
                    showImage: approverFilter.isSignDigitalCertificate
                      ? true
                      : approverFilter.role + "" == "1"
                      ? true
                      : false,
                  }.showImage;
              // check init btn disabled
              if (!this.isShowImage) {
                this.isDisableSignBtn = false;
              } else {
                if (this.isSelectedPosition.getValue()) {
                  this.isDisableSignBtn = false;
                } else {
                  this.isDisableSignBtn = true;
                }
              }
            } else {
              if (approverFilter.role == 1) {
                this.isShowImage = true;
              } else {
                this.isShowImage = false;
              }
            }
            setTimeout(() => {
              this.isShowPdf = true;
              this.setTitleFilePDF();
              this.cd.detectChanges();
            }, 0);
          } else {
            this.loadConfigAndCertificates("");
          }
        });
    } else {
      this.loadConfigAndCertificates("");
    }

    // kiểm tra xem có quyền quản lý tt doanh nghiệp hay không
    if (this.permissions.includes(1)) {
      this.isHasPermissionAddCert = true;
    }

    this.getUserConfig();
  }

  // start fn group contract
  getDocumentById(id: string) {
    if (id) {
      const goFrom = this.route.snapshot.queryParamMap.get('goFrom');
      this.documentMohaService.getDocumentById(id).subscribe(res => {
        if(res.data){
            this.customerMohaId= res.data.customerMohaId;
            this.creatorSide = res.data.creatorSide;
            const data = localStorage.getItem('userType');
        const userType = data;
        
        if(this.isEmploymentContract && this.customerMohaId && !this.creatorSide && (Number(userType) === 5 || Number(userType) === 3)){
          this.displayCheckbox = true;
          this.isAgree = false;
        }else{
          this.displayCheckbox = false;
          this.isAgree = true;
        }
          }
        });
        
      this.documentService.getDocumentById(id).subscribe((rs) => {
        if (!rs || !rs.data) {
          if (rs && rs.message) {
            this.toastr.error(rs.message);
          }
          return;
        }
        // const tempEnterprise = JSON.parse(localStorage.getItem('tempEnterprise'));
        // const businessType = tempEnterprise.businessType;

        // console.log("businessType: " + businessType);
        
        // if(this.customerMohaId){
        //   if(!this.creatorSide){
        //   if(Number(userType) === 5 || Number(userType) === 3){
        //   this.disableAgree = false;
        //   }else{
        //     this.disableAgree = true;
        //     this.isAgree = true;
        //   }
        // }else{
        //   this.disableAgree = true;
        //     this.isAgree = true;
        // }
        // }else{
        //   this.disableAgree = true;
        //     this.isAgree = true;
        // }

        // if(!this.isEmploymentContract){
        //   if(this.disableAgree == true){
        //   this.displayCheckbox = false;
        //   this.isAgree = true;}
        //   else{
        //     this.displayCheckbox = true;
        //     this.isAgree = false;
        //   }
          
        // }else{
        //   this.displayCheckbox = true;
        //   this.isAgree = false;
        // }

        this.document = rs.data.contractDTO;
        this.customerImagesConfig =
          rs.data.serviceType &&
          rs.data.serviceType.customerImagesConfig &&
          rs.data.serviceType.customerImagesConfig.length
            ? [...rs.data.serviceType.customerImagesConfig]
            : ["default_image", "download_sign_image", "draw_sign_image"];
        this.scopeType = this.document.scopeType || 0;
        this.signPosition = rs.data.contractSignEntityList;
        if (this.signPosition && this.signPosition.length > 0) {
          this.imageData = rs.data.contractSignEntityList.map((item) => {
            const image = {
              positionX: item.x,
              positionY: item.y,
              pageNumber: item.pageNumber,
              signType: item.signType,
              widthRectangle: item.width,
              heightRectangle: item.height,
              id: item.id,
              zoom: 1,
              fileId: item.fileId,
              signPositionId: item.id,
              contractSignId: undefined,
            };

            // Trường hợp tài khoản không chứng thực, kí gửi lên contractSignId
            if (this.isNotAttestedUser) image.contractSignId = item.id;

            return image;
          });
        } else {
          this.isAllowSelectSignPosition = true;
          this.signPosition = [];
        }

        if (!this.listPdfSrc) {
          // TH reload lại page
          this.renderFilePDFAfterReloadPage();
        } else {
          this.renderFilePDF();
        }
        this.checkSignManual();
      });
    }
  }
  // end fn group contract

  // start fn group sign method
  loadConfigAndCertificates(role) {
    this.digitalCertificateService
      .getServiceTypeByContractId(this.contractId, role)
      .subscribe(
        async (res) => {
          if (res.data) {
            // type = 2 là khách hàng cá nhân mới check
            // if (parseInt(localStorage.getItem('typeAllowCheck')) === 2) {
            res.data.allowImage
              ? (this.allowImage = res.data.allowImage)
              : (this.allowImage = false);
            res.data.allowOtp
              ? (this.allowOtp = res.data.allowOtp)
              : (this.allowOtp = false);
              this.isEmploymentContract = res.data.isEmploymentContract;
            this.checkMethodSign();

            this.supportEkyc = !!Number(res.data.ekycSupportConfig);
            this.ekycSupportConfig = res.data.ekycSupportConfig;
            if (this.supportEkyc) {
              await this.getQuantityEkyc();
            }
            this.checkCertNumber = res.data.checkCertNumber;
            this.isEmploymentContract = res.data.isEmploymentContract;
            this.checkOtp = res.data.checkOtp;
            this.checkName = res.data.checkName;
            this.digitalCertificateService
              .getPermissionHSM(localStorage.getItem("enterpriseId"))
              .subscribe((res) => {
                if (res && res.success) {
                  this.isHsmPermission = res.data.enableHsm;
                  this.checkEasyCa = res.data.isEnableEasyCa;
                  this.getCertificateLastest();
                  this.getCertificates();
                }
              });
            
          } else {
            this.toastr.error(
              this.message.getMessage(
                "messages.error_data_wrong_digital_certificate"
              )
            );
          }
        },
        (error) => {
          this.toastr.error(
            this.message.getMessage(
              "messages.error_data_wrong_digital_certificate"
            )
          );
        }
      );
  }

  getCertificateLastest() {
    this.documentService.getCertificateLastest().subscribe((rs) => {
      this.certificateLastest = rs.data;
    });
  }

  getCertificates(isAfterAddCertificate?: boolean) {
    this.digitalCertificateService
      .getCertificates(this.enterpriseId)
      .subscribe((rs) => {
        this.imageCertificates = [];
        this.certificates = rs.data;
        this.isCertificateDefault = false;
        let indexCer = 0;
        let countList = -1;
        let indexList = 0;
        if (this.certificates.length > 0) {
          for (const cerType of this.certificates) {
            countList++;
            cerType.listCert = cerType.listCert.map((item, index) => {
              if (
                item.defaultCertificate &&
                !(item.typeCertificate === 0 && !this.isHsmPermission)
              ) {
                if (!this.isEmploymentContract) {
                  this.isCertificateDefault = true;
                  indexCer = index;
                  indexList = countList;
                } else {
                  if (cerType.type == 10) {
                    this.isCertificateDefault = true;
                    indexCer = index;
                    indexList = countList;
                  } 
                }
              }
              const { imagePath } = item;
              if (imagePath) {
                const imageDataBlob = this.commonService.b64toBlob(imagePath);
                const blobUrl = URL.createObjectURL(imageDataBlob);
                return {
                  ...item,
                  imageUrl: blobUrl,
                };
              } else {
                return {
                  ...item,
                  imageUrl: "",
                };
              }
            });
          }
          this.imageCertificates = [
            ...this.imageCertificates,
            ...this.certificates.filter((certificate) => {
              if(!this.isEmploymentContract){
              if (
                certificate.type === this.enumSignMethod.SIGN_SERVER &&
                !this.isHsmPermission
              ) {
                return false;
              }
              if (!this.allowOtp) {
                return (
                  Number(certificate.type) !== this.enumSignMethod.SIGN_OTP
                );
              } else return certificate;
              }else{
                return certificate;
              }
            }),
          ];
          this.imageCertificates.forEach((cer) => {
            if (cer.type === this.enumSignMethod.EASY_CA) {
              if (cer.listCert.length > 0) {
                cer.listCert.forEach((element) => {
                  element.passwordVisibility = false;
                  if (element.pin && element.pin.length > 0) {
                    element.isSavePin = true;
                  } else {
                    element.isSavePin = false;
                  }
                });
              }
            }
          });

          this.isHaveDataSignMethodHSM = !!this.imageCertificates.filter(
            (cretificate) =>
              cretificate.type === this.enumSignMethod.SIGN_SERVER
          ).length;
          this.isHaveDataSignMethodUSB = !!this.imageCertificates.filter(
            (cretificate) =>
              cretificate.type === this.enumSignMethod.SIGN_USB_TOKEN
          ).length;
          this.isHaveDataSignMethodSIM_CA = !!this.imageCertificates.filter(
            (cretificate) =>
              cretificate.type === this.enumSignMethod.SIGN_SIM_CA
          ).length;
          this.isHaveDataSignMethodCLOUD_CA = !!this.imageCertificates.filter(
            (cretificate) => cretificate.type === this.enumSignMethod.CLOUD_CA
          ).length;
          this.isHaveDataSignMethodEASY_CA = !!this.imageCertificates.filter(
            (cretificate) => cretificate.type === this.enumSignMethod.EASY_CA
          ).length;
          this.isHaveDataSignMethodOTP = !!this.imageCertificates.filter(
            (cretificate) => cretificate.type === this.enumSignMethod.SIGN_OTP
          ).length;
          this.isHaveDataSignMethodVNEID = !!this.imageCertificates.filter(
            (cretificate) => cretificate.type === this.enumSignMethod.VNEID
          ).length;
        } else {
          this.indexSelect = 0;
          if (this.isDisplaySignatureTab(1)) {
            this.systemImageSign = true;
            this.isUploadImage = false;
            this.avatarUrl = null;
            this.convertHtmlToImage();
            this.cd.detectChanges();
            setTimeout(() => {
              this.setFontSize(imageConfigViewScaleId);
              this.setFontSize(imageConfigRenderId);
            }, 100);
          } else if (this.isDisplaySignatureTab(2)) {
            this.isUploadImage = true;
            this.isSelectDrawImage = false;
            this.systemImageSign = false;
            this.signatureFileDefault = null;
            this.canvasService.setCanvasSignatureImageUrl("");
            if (this.canvasComponent) {
              this.canvasComponent.clearCanvas();
            }
            this.avatarUrl = null;
          } else {
            this.isSelectDrawImage = true;
            this.systemImageSign = false;
            this.isUploadImage = false;
            this.imagePreviewWidth = 0;
            this.imagePreviewHeight = 0;
            this.canvasService.setCanvasSignatureImageUrl(
              this.signatureImageDraw
            );
            this.canvasService.setIsSelectSignDraw(true);
          }
        }

        if (this.imageCertificates.length > 0) {
          // Select certificate
          if (this.isCertificateDefault) {
            this.selectedCert =
              this.imageCertificates[indexList].listCert[indexCer];
          } else {
            if (this.certificateLastest && this.certificateLastest.idDetail) {
              const dataSelecdCert = this.imageCertificates.find(
                (data) => data.type === this.certificateLastest.typeCertificate
              )
                ? this.imageCertificates
                    .find(
                      (data) =>
                        data.type === this.certificateLastest.typeCertificate
                    )
                    .listCert.filter(
                      (cert) =>
                        cert.idDetail === this.certificateLastest.idDetail
                    )
                : null;
              if (dataSelecdCert && dataSelecdCert.length) {
                this.selectedCert = dataSelecdCert[0];
              } else {
                this.selectedCert = this.imageCertificates[0].listCert[0];
              }
            } else {
              console.log(this.enterpriseInfo.customerType);
              if (
                this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL
              ) {
                if (this.isHaveDataSignMethodOTP) {
                  this.selectedCert = this.imageCertificates.filter(
                    (cretificate) =>
                      cretificate.type === this.enumSignMethod.SIGN_OTP
                  )[0].listCert[0];
                } else if (this.isHaveDataSignMethodCLOUD_CA) {
                  this.selectedCert = this.imageCertificates.filter(
                    (cretificate) =>
                      cretificate.type === this.enumSignMethod.CLOUD_CA
                  )[0].listCert[0];
                } else if (this.isHaveDataSignMethodEASY_CA) {
                  this.selectedCert = this.imageCertificates.filter(
                    (cretificate) =>
                      cretificate.type === this.enumSignMethod.EASY_CA
                  )[0].listCert[0];
                } else if (this.isHaveDataSignMethodVNEID) {
                  this.selectedCert = this.imageCertificates.filter(
                    (cretificate) =>
                      cretificate.type === this.enumSignMethod.VNEID
                  )[0].listCert[0];
                } else {
                  this.selectedCert = this.imageCertificates[0].listCert[0];
                }
              } else {
                if (this.isHaveDataSignMethodCLOUD_CA) {
                  this.selectedCert = this.imageCertificates.filter(
                    (cretificate) =>
                      cretificate.type === this.enumSignMethod.CLOUD_CA
                  )[0].listCert[0];
                } else if (this.isHaveDataSignMethodEASY_CA) {
                  this.selectedCert = this.imageCertificates.filter(
                    (cretificate) =>
                      cretificate.type === this.enumSignMethod.EASY_CA
                  )[0].listCert[0];
                } else {
                  this.selectedCert = this.imageCertificates[0].listCert[0];
                }
              }
            }
          }

          if (
            this.selectedCert &&
            (this.selectedCert.issuedTo || this.selectedCert.certificateName)
          ) {
            const issueTo =
              this.selectedCert.issuedTo || this.selectedCert.certificateName;
            this.signConfig.enterpriseName.value = issueTo;
          } else {
            this.signConfig.enterpriseName.value = this.enterpriseName;
          }
          if (this.selectedCert && this.selectedCert.phoneNumber) {
            const phoneNumber = {
              value: null,
              enabled: false,
              label: "enterprise_contract.image_signing.no_image.phone_number",
            };
            this.signConfig = {
              enterpriseName: this.signConfig.enterpriseName,
              phoneNumber: phoneNumber,
              ...this.signConfig,
            };

            this.signConfig.phoneNumber.value = this.selectedCert.phoneNumber;
          }
          // this.signConfig.email.value = this.selectedCert.email;

          if (this.selectedCert.id) {
            
              this.typeCertificate = this.selectedCert.typeCertificate;
            this.signFlowDocumentWithCertificate(isAfterAddCertificate);
          }
        }
        
      });
  }

  async selectCertificate(certificate) {
    this.selectedCert = certificate;
    if (
      this.selectedCert &&
      (this.selectedCert.issuedTo || this.selectedCert.certificateName)
    ) {
      const issueTo =
        this.selectedCert.issuedTo || this.selectedCert.certificateName;
      this.signConfig.enterpriseName.value = issueTo;
    } else {
      this.signConfig.enterpriseName.value = this.enterpriseName;
    }
    if (this.selectedCert && this.selectedCert.phoneNumber) {
      const phoneNumber = {
        value: null,
        enabled: false,
        label: "enterprise_contract.image_signing.no_image.phone_number",
      };
      this.signConfig = {
        enterpriseName: this.signConfig.enterpriseName,
        phoneNumber: phoneNumber,
        ...this.signConfig,
      };
      this.signConfig.phoneNumber.value = this.selectedCert.phoneNumber;
    }
    // this.signConfig.email.value = this.selectedCert.email;
    if (
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP &&
      this.supportEkyc &&
      this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL
    ) {
      this.isShowWebcam = true;
    } else {
      this.isShowWebcam = false;
    }

    if (this.selectedCert.imageUrl !== "" && this.isDisplaySignatureTab(2)) {
      this.isUploadImage = true;
      this.indexSelect = this.isDisplaySignatureTab(1) ? 1 : 0;
      this.signatureFileDefault = null;
      this.canvasService.setCanvasSignatureImageUrl("");
      if (this.canvasComponent) {
        this.canvasComponent.clearCanvas();
      }
      fetch(this.selectedCert.imageUrl)
        .then((r) => r.blob())
        .then((blobFile) => {
          this.fileUpload = new File([blobFile], "fileNameGoesHere", {
            type: "image/png",
          });
          if (this.fileUpload) {
            this.handlePreviewFromFileUpload(this.fileUpload, true);
          }
        });
    } else {
      if (
        !this.isDisplaySignatureTab(1) &&
        !this.isDisplaySignatureTab(2) &&
        this.isDisplaySignatureTab(3)
      ) {
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.imageUrlPreview = null;
      }
      if (this.isDisplaySignatureTab(1)) {
        this.indexSelect = 0;
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl("");
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.indexSelect = this.isDisplaySignatureTab(1) ? 1 : 0;
        this.isUploadImage = true;
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.signatureFileDefault = null;
        this.canvasService.setCanvasSignatureImageUrl("");
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.avatarUrl = null;
      } else {
        this.indexSelect = this.isDisplaySignatureTab(1)
          ? 2
          : this.isDisplaySignatureTab(2)
          ? 1
          : 0;
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setCanvasSignatureImageUrl(null);
      }
    }
  }

  async signFlowDocumentWithCertificate(isAfterAddCertificate?: boolean) {
    if (
      this.selectedCert &&
      (this.selectedCert.issuedTo || this.selectedCert.certificateName)
    ) {
      const issueTo =
        this.selectedCert.issuedTo || this.selectedCert.certificateName;
      this.signConfig.enterpriseName.value = issueTo;
    } else {
      this.signConfig.enterpriseName.value = this.enterpriseName;
    }
    if (this.selectedCert && this.selectedCert.phoneNumber) {
      const phoneNumber = {
        value: null,
        enabled: false,
        label: "enterprise_contract.image_signing.no_image.phone_number",
      };
      this.signConfig = {
        enterpriseName: this.signConfig.enterpriseName,
        phoneNumber: phoneNumber,
        ...this.signConfig,
      };
      this.signConfig.phoneNumber.value = this.selectedCert.phoneNumber;
    }
    // this.signConfig.email.value = this.selectedCert.email;
    if (this.selectedCert.imageUrl !== "" && this.isDisplaySignatureTab(2)) {
      this.isUploadImage = true;
      this.indexSelect = this.isDisplaySignatureTab(1) ? 1 : 0;
      fetch(this.selectedCert.imageUrl)
        .then((r) => r.blob())
        .then((blobFile) => {
          this.fileUpload = new File([blobFile], "fileNameGoesHere", {
            type: "image/png",
          });
          if (this.fileUpload) {
            this.handlePreviewFromFileUpload(this.fileUpload, true);
          }
        });
    } else {
      if (this.isDisplaySignatureTab(1)) {
        this.indexSelect = 0;
        this.systemImageSign = true;
        this.isUploadImage = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.avatarUrl = null;
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.indexSelect = this.isDisplaySignatureTab(1) ? 1 : 0;
        this.isUploadImage = true;
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.signatureFileDefault = null;
        this.canvasService.setCanvasSignatureImageUrl("");
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.avatarUrl = null;
      } else {
        this.indexSelect = this.isDisplaySignatureTab(1)
          ? 2
          : this.isDisplaySignatureTab(2)
          ? 1
          : 0;
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        // this.canvasService.canvasImage.subscribe((imgUpload) => {
        //   if (imgUpload) {
        //     this.fileUpload = imgUpload;
        //   }
        // });
        this.canvasService.setCanvasSignatureImageUrl(this.signatureImageDraw);
        this.canvasService.setIsSelectSignDraw(true);
      }
    }

    if (
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_USB_TOKEN
    ) {
      // check connect plugins
      if (!isAfterAddCertificate) {
        this.blockUI.start("");
        await checkPlugin(this);
      }
      if (this.isAllowSelectSignPosition) {
        this.onStamped();
      }
    } else {
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP &&
        this.supportEkyc &&
        this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL
      ) {
        this.isShowEKYC = true;
        this.isShowWebcam = true;
        // this.validateDataCertificate();
      }
    }
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + "</a>";
  }

  showErrMsgTransleFormat(msg) {
    const link = this.linkDownSignPlugin();

    this.dialog.open(AlertComponent, {
      width: "370px",
      data:
        this.message.getMessage(msg) +
        this.createATag(this.linkDownSignPlugin("WINDOWS"), "Windows, ") +
        this.createATag(this.linkDownSignPlugin("MACOS"), "MacOS, ") +
        this.createATag(this.linkDownSignPlugin("LINUX"), "ViettelOS"),
    });
  }

  showErrMsgTransle(msg) {
    if (msg === "messages.not_initPlugin") {
      const link = this.linkDownSignPlugin();
      msg = "messages.initPlugin_faile";

      this.signError =
        this.message.getMessage(msg) +
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        this.createATag(this.linkDownSignPlugin("WINDOWS"), "Windows, ") +
        this.createATag(this.linkDownSignPlugin("MACOS"), "MacOS, ") +
        this.createATag(this.linkDownSignPlugin("LINUX"), "ViettelOS");
      //sign cancel
      this.isCancel = true;
      this.documentService.setCancelFlow(true);
      const data = {
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        signMethod: this.selectedCert.typeCertificate,
        contractId: this.document.id,
        mainContractAttachments: [],
        certificate: this.sign.certificate,
        digitalCertificateDetailId: this.selectedCert.idDetail,
      };
      this.errorStatus = "messages.stop_sign_document";
      this.userCancel = false;
      this.signDocumentService.signCancel(data).subscribe((res) => {});
    } else {
      this.errorStatus = msg;
    }
  }

  validateDataCertificate() {
    if (this.selectedCert.typeCertificate === 3) {
      if (this.checkOtp) {
        const enterprisePhone =
          this.digitalCertificateService.formatPhoneNumber(
            localStorage.getItem("enterprisePhoneProcessing")
          );
        if (
          enterprisePhone &&
          this.selectedCert.phoneNumber !== enterprisePhone
        ) {
          const message = this.commonService.format(
            this.message.getMessage(
              "messages.digital_certificate_validate_phone"
            ),
            enterprisePhone
          );
          const dialogRe = this.dialog.open(AlertComponent, {
            width: "350px",
            data: message,
          });
          dialogRe.afterClosed().subscribe((rs) => {
            if (rs) {
              this.dialogRef.close();
            }
          });
          this.isDisableSignBtn = true;
          return;
        }
      }
    }

    //Check Loại giấy tờ
    if (
      this.isShowEKYC &&
      this.isStillQuantityEkyc &&
      this.supportEkyc &&
      !this.isCertificateSupport
    ) {
      // thông báo lỗi 'digital_certificate_management.certificate_not_support'
      const dialogRe = this.dialog.open(AlertComponent, {
        width: "350px",
        data: this.message.getMessage(
          "digital_certificate_management.certificate_not_support"
        ),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
      });
      this.isDisableSignBtn = true;
      return;
    }

    if (this.isShowEKYC && !this.isStillQuantityEkyc && this.supportEkyc) {
      const dialogRe = this.dialog.open(AlertComponent, {
        width: "350px",
        data: this.message.getMessage(
          "digital_certificate_management.quantity_ekyc_not_enough"
        ),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
      });
      this.isDisableSignBtn = true;
      return;
    }
  }

  handlePreviewFromFileUpload(
    fileUpload: File,
    isCertificateDefault?: boolean
  ) {
    this.commonService
      .getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        if (isCertificateDefault) {
          this.avatarUrl = this.imageUrlPreview;
        }
        const img = new Image();
        img.src = this.imageUrlPreview;
        img.onload = () => {
          this.widthImageRender = img.width;
          this.heightImageRender = img.height;
          if (
            this.indexSelect === (this.isDisplaySignatureTab(1) ? 1 : 0) &&
            this.isDisplaySignatureTab(2)
          ) {
            this.imagePreviewWidth = img.width;
            this.imagePreviewHeight = img.height;
          }
        };
        this.documentService.setImageSignature({
          url: this.imageUrlPreview,
          fileUpload: this.fileUpload,
        });
      });
  }

  openDialogAddCert() {
    this.dialogRef = this.dialog.open(AddDigitalCertificateComponent, {
      width:
        this.mediaBreakpoint === SCREEN_SIZE.XS ||
        this.mediaBreakpoint === SCREEN_SIZE.SM
          ? "100%"
          : "80%",
      maxWidth:
        this.mediaBreakpoint === SCREEN_SIZE.XS ||
        this.mediaBreakpoint === SCREEN_SIZE.SM
          ? "90vw"
          : "80vw",
      panelClass: "scontract-overlay-dialog",
      data: {
        isCreateMysign: true,
        isEmploymentContract: this.isEmploymentContract,
      },
    });
    this.dialogRef.afterClosed().subscribe((result) => {
      if (this.dialogRef.componentInstance.success) {
        this.getCertificates(true);
      }
    });
  }

  getDisplayedColumns() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplay = this.columnDefinitions
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplay = this.columnDefinitions.map((cd) => cd.def);
        break;
    }
  }

  getDisplayedColumnsOTP() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayOTP = this.columnDefinitionsOTP.map(
          (cd) => cd.def
        );
        break;
    }
  }

  getDisplayedColumnsCloudCA() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayCloudCA = this.columnDefinitionsCloudCA.map(
          (cd) => cd.def
        );
        break;
    }
  }
  getDisplayedColumnsEasyCA() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayEasyCA = this.columnDefinitionsEasyCA.map(
          (cd) => cd.def
        );
        break;
    }
  }

  getDisplayedColumnsVNeID() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayVNeID= this.columnDefinitionsVNeID
          .filter((cd) => cd.showXS)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayVNeID= this.columnDefinitionsVNeID
          .filter((cd) => cd.showSM)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayVNeID= this.columnDefinitionsVNeID
          .filter((cd) => cd.showMD)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayVNeID= this.columnDefinitionsVNeID
          .filter((cd) => cd.showLG)
          .map((cd) => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayVNeID = this.columnDefinitionsVNeID
          .filter((cd) => cd.showXL)
          .map((cd) => cd.def);
        break;
      default:
        this.columnsToDisplayVNeID = this.columnDefinitionsVNeID.map(
          (cd) => cd.def
        );
        break;
    }
  }
  // end fn group sign method

  // start fn group signature image
  nzSelectChange(index = 0) {
    const indexSystemTab = 0;
    const indexUploadTab = this.isDisplaySignatureTab(1) ? 1 : 0;
    const indexDrawTab = this.isDisplaySignatureTab(1)
      ? 2
      : this.isDisplaySignatureTab(2)
      ? 1
      : 0;
    this.indexSelect = index;
    if (
      this.selectedCert.typeCertificate !== this.enumSignMethod.SIGN_NO_CERT
    ) {
      if (index === indexDrawTab) {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.canvasImage.subscribe((imgUpload) => {
          if (imgUpload) {
            this.fileUpload = imgUpload;
          }
        });
        this.canvasService.setCanvasSignatureImageUrl(this.signatureImageDraw);
      } else if (index === indexUploadTab) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl && this.isDisplaySignatureTab(2)) {
          fetch(this.selectedCert.imageUrl)
            .then((r) => r.blob())
            .then((blobFile) => {
              this.fileUpload = new File([blobFile], "fileNameGoesHere", {
                type: "image/png",
              });
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        if (!this.selectedCert.imageUrl) {
          this.avatarUrl = null;
        }
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
        setTimeout(() => {
          this.documentService.setImageSignature({
            url: this.signatureImageDefault,
            fileUpload: this.signatureFileDefault,
          });
        }, 100);
        if (this.signatureFileDefault) {
          this.handlePreviewFromFileUpload(this.fileUpload);
        } else {
          this.convertHtmlToImage();
        }
      }
    } else {
      if (index === indexUploadTab) {
        this.systemImageSign = false;
      }

      if (index === indexSystemTab) {
        this.systemImageSign = true;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = "";
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    }
  }

  isDisplaySignatureTab(value): boolean {
    const userType = localStorage.getItem("userType");
    let currentValue = "";
    switch (value) {
      case 1:
        currentValue = "default_image";
        break;
      case 2:
        currentValue = "download_sign_image";
        break;
      case 3:
        currentValue = "draw_sign_image";
        break;
    }
    if (
      userType == "3" ||
      userType == "4" ||
      userType == "5" ||
      this.isCustomer
    ) {
      if (this.customerImagesConfig.includes(currentValue)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
  };

  dummyRequest = ({ file, onSuccess, onError }) => {
    this.fileUpload = file;
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  handleChange(info: { file: NzUploadFile }): void {
    // this.isFormChanging = true;

    switch (info.file.status) {
      case "uploading":
        this.loading = true;
        break;
      case "done":
        // Get this url from response in real world.
        // tslint:disable-next-line:no-non-null-assertion
        this.commonService.getBase64Avatar(
          info.file!.originFileObj!,
          (imgUrl: string) => {
            this.loading = false;
            // tslint:disable-next-line:radix
            const img = new Image();
            // Set the src attribute to your URL
            img.src = imgUrl;
            this.imagePreviewWidth = img.width;
            this.imagePreviewHeight = img.height;
            // When the image is loaded, read the available properties
            this.avatarUrl = imgUrl;
            this.imageUrlPreview = imgUrl;
            this.signatureImageUpload = imgUrl;
            this.documentService.setImageSignature({
              url: imgUrl,
              fileUpload: this.fileUpload,
            });
          }
        );
        break;
      case "error":
        this.toastr.error("Network error");
        this.loading = false;
        break;
    }
  }

  onSelectDrawSign() {
    this.canvasService.setIsSelectSignDraw(true);
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfig);
  }

  getUserConfig() {
    this.signDocumentService
      .getUserConfigAsync()
      .pipe(
        tap((res) => {
          if (res.success && res.data) {
            for (const key in this.signConfig) {
              this.signConfig[key].enabled = res.data[key] || false;
            }

            this.signConfig.enterpriseName.value = this.enterpriseName;

            this.signConfig.address.value = res.data["addressDetail"] || "";
            this.signConfig.position.value = res.data["positionDetail"] || "";
            this.signConfig.confirmBy.value = res.data["signature"] || "";
            this.signConfig.fontFamily.value = res.data["fontFamily"] || "";
            this.signConfig.fontWeight.value = res.data["fontWeight"] || "";
            this.signConfig.fontStyle.value = res.data["fontStyle"] || "";
            this.signConfig.signatureImageBase64.value =
              res.data["signatureImageBase64"] || "";
            this.signConfig.signatureImageName.value =
              res.data["signatureImageName"] || "";
            this.signConfig.signaturePosition.value =
              res.data["signaturePosition"] || "";
            this.signConfig.signatureRatio.value =
              res.data["signatureRatio"] || "";

            this.signConfig.fontFamily.enabled = false;
            this.signConfig.fontWeight.enabled = false;
            this.signConfig.fontStyle.enabled = false;
            this.signConfig.signatureImageBase64.enabled = false;
            this.signConfig.signatureImageName.enabled = false;
            this.signConfig.signaturePosition.enabled = false;
            this.signConfig.signatureRatio.enabled = false;
            this.signConfig.contentPosition.value =
              res.data["contentPosition"] === "false"
                ? ContentPosition.left
                : res.data["contentPosition"];
            this.signConfig.contentPosition.enabled = false;

          }
        }),
        switchMap(() => {
          return forkJoin({
            email: this.signDocumentService.getEmailAsync(),
            date: this.signDocumentService.getDateAsync(),
          });
        })
      )
      .subscribe((res) => {
        if (res) {
          this.signConfig.signingTime.value = res.date.success
            ? res.date.data.date
            : "";
          this.signConfig.email.value = res.email.success ? res.email.data : "";

          this.cd.detectChanges();
          setTimeout(() => {
            this.setFontSize(imageConfigViewScaleId);
            this.setFontSize(imageConfigRenderId);
          }, 100);
        }
      });
  }

  showConfig(key: string): boolean {
    if (key === "greenTick") {
      return false;
    }

    // các value-carrier chỉ dùng làm dữ liệu/style (ảnh nhúng base64 render riêng bằng <img>,
    // font/position là style) — không bao giờ là dòng text; không chặn thì ảnh nhúng của
    // cert type 0 sẽ bị in nguyên chuỗi base64 ra preview (giống fix sign-flow-document-v2)
    if (
      key === "signatureImageBase64" ||
      key === "signatureImageName" ||
      key === "signaturePosition" ||
      key === "signatureRatio" ||
      key === "fontFamily" ||
      key === "fontStyle" ||
      key === "fontWeight" ||
      key === "contentPosition"
    ) {
      return false;
    }

    if (this.selectedCert.typeCertificate !== this.enumSignMethod.SIGN_OTP) {
      if (this.selectedCert.typeCertificate) {
        if (key === "phoneNumber") {
          this.signConfig.phoneNumber.enabled = false;
          return false;
        }
      }
      if (key === "confirmBy") {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
      if (key === "signatureImage") {
        return false;
      }

      if (key === "isDraw") {
        return false;
      }
    } else {
      if (key === "confirmBy" && this.scopeType !== 2) {
        this.signConfig.confirmBy.enabled = true;
        return true;
      } else if (key === "confirmBy" && this.scopeType === 2) {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }

      if (key === "signatureImage") {
        return false;
      }

      if (key === "isDraw") {
        return false;
      }
    }

    return this.signConfig[key].enabled;
  }

  getNumber(value: any) {
    return value.split(":") || [];
  }

  setSizeFrameImage() {
    if (this.signConfig.signatureImage.enabled) {
      switch (this.signConfig.signaturePosition.value) {
        case "left":
        case "right":
          return {
            width: "370px",
            height: "136px",
          };
        case "top":
        case "bottom":
          return {
            width: "300px",
            height: "237px",
          };
      }
    } else {
      return {
        width: "300px",
        height: "136px",
      };
    }
  }

  setFontSize(id: string) {
    const listElement: any = document.getElementsByClassName(id);
    for (let el of listElement) {
      if (!el) {
        return;
      }
      el.style.wordBreak = "break-word";
      if (id === imageConfigViewScaleId) {
        if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
          el = el.lastElementChild.lastElementChild as HTMLElement;
      }

      if (el) {
        let fontSize = 56;
        let minSize = 32;
        let padding = 40;
        if (id === imageConfigFormPreviewId) {
          fontSize /= 4;
          minSize /= 4;
          padding /= 4;
        }

        el.style.fontSize = fontSize + "px";

        let parent;
        if (
          this.signConfig.signaturePosition.value === "top" ||
          this.signConfig.signaturePosition.value === "bottom"
        ) {
          parent = el.parentElement;
        } else {
          parent = el.parentElement.parentElement;
        }
        const parentHeight = parent.offsetHeight;
        let height = el.offsetHeight;

        while (height > parentHeight - padding && fontSize > minSize) {
          if (id === imageConfigFormPreviewId) {
            fontSize -= 1 / 4;
          } else {
            fontSize--;
          }
          el.style.fontSize = fontSize + "px";
          height = el.offsetHeight;
        }
      }
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  // end fn group signature image

  // start fn group EKYC
  getEnterprise() {
    this.enterpriseService
      .getDetailCusByEnterprise(this.contractId)
      .subscribe((res) => {
        if (res && res.data) {
          this.enterpriseInfo = res.data;
          if (
            +res.data.representativeCertificateId ===
            this.certificateTypeID.HO_CHIEU
          ) {
            this.isPassport = true;
          } else if (
            +res.data.representativeCertificateId ===
              this.certificateTypeID.CCCD ||
            +res.data.representativeCertificateId ===
              this.certificateTypeID.CMTND
          ) {
            this.isPassport = false;
          }

          if (
            +this.enterpriseInfo.representativeCertificateId ===
              this.certificateTypeID.CCCD ||
            +this.enterpriseInfo.representativeCertificateId ===
              this.certificateTypeID.CMTND ||
            +this.enterpriseInfo.representativeCertificateId ===
              this.certificateTypeID.HO_CHIEU
          ) {
            this.isCertificateSupport = true;
          }
        }
      });
  }

  async getQuantityEkyc() {
    if (!this.contractId) return of(null);
    const res = await this.signDocumentService
      .getQuantityEkyc(this.contractId)
      .toPromise();
    if (res.success === true && res.data) {
      if (this.ekycSupportConfig == 1 && res.data.quantityEkyc)
        this.isStillQuantityEkyc = true;
      if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc)
        this.isStillQuantityEkyc = true;
      if (res.data.quantityEkyc) this.isQuantityEkyc = true;
      if (res.data.quantityAdvancedEkyc) this.isQuantityAdvancedEkyc = true;
    } else {
      this.toastr.error(this.message.getMessage(res.message));
    }
  }

  getQuantityEkycBeforeNext(): Observable<boolean> {
    this.blockUI.start("");
    return this.signDocumentService.getQuantityEkyc(this.contractId).pipe(
      map((res) => {
        let isPass = false;
        this.blockUI.stop();
        if (res.success === true && res.data) {
          if (this.ekycSupportConfig == 1 && res.data.quantityEkyc)
            isPass = true; //normal
          if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc)
            isPass = true; //Advance
        } else {
          this.toastr.error(this.message.getMessage(res.message));
        }
        return isPass;
      })
    );
  }

  private onIdentityEKYC() {
    const dataImg = this.ekyc.getDataImage();
    if (!dataImg) return;
    let body = {
      typeImage: dataImg.typeImage,
      contractId: this.sign.contractId,
      images: dataImg.images.map((image) => {
        return { base64Image: image.base64Image, type: image.type };
      }),
    };

    if (
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP ||
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_NO_CERT
    ) {
      this.validateEKYCOtp(body);
    }
  }

  private validateEKYCOtp(body: any): void {
    this.blockUI.start("");
    this.signDocumentService.valiadateEkycOtpSupport(body).subscribe((res) => {
      this.blockUI.stop();
      if (res && res.success) {
        if (
          this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP
        ) {
          this.processSignOTP();
        } else if (
          this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_NO_CERT
        ) {
          this.processSignNoCertificate();
        }
      } else {
        if (res && !res.success) {
          let dialogRef;
          if (res.code === "0x002413")
            dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
              width: "350px",
              data: {
                message: this.message.getMessage("messages.sign_fail_ekyc"),
              },
            });
          else
            dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
              width: "350px",
              data: {
                message: this.message.getMessage(
                  "messages.confirm_resign_ekyc"
                ),
              },
            });
          dialogRef.afterClosed().subscribe((rs) => {
            if (rs) {
              this.dialog.closeAll();
              setTimeout(() => {
                this.openDialogSignEKYC(this.templateRefEKYC);
              }, 10);
            } else {
              let queryParams: any = {
                routeLink: "/home-enterprise/search-document-sign/",
                goFrom: this.goFrom,
              };
              this.router.navigate(
                [`/home-enterprise/view-document/${this.contractId}`],
                { queryParams }
              );
            }
          });
        }
      }
    });
  }

  // end fn group EKYC

  // start fn group with PDF

  reRenderSignature() {
    if (this.document) {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter((sign) => {
        return (
          sign.fileId === fileId &&
          (sign.signType === this.signPositionTypes.IMAGE ||
            sign.signType === this.signPositionTypes.COMBINE)
        );
      });
      for (let sign of signs) {
        let signatureId =
          document.getElementById(`sign-${sign.id}`) ||
          document.getElementById("show-frames-notification");
        const signPositionData = this.signPosition.find(
          (e) => e.id === sign.id
        );
        const width = signPositionData.width;
        const height = signPositionData.height;
        if (signatureId) {
          signatureId.innerHTML = this.generateStampContentWidthHeight(
            Number(width),
            Number(height),
            null,
            true
          );
          if (this.canMoveAndResize) {
            const resizer = this.renderer.createElement("div");
            this.renderer.setAttribute(
              resizer,
              "class",
              "resize-div-bot-right"
            );
            resizer.style.setProperty(
              "--zoom",
              (this.zoomLevel / 100).toString()
            );
            const rerenderSign = () => {
              signatureId.appendChild(resizer);
              resizer.style.removeProperty("--zoom");
              resizer.style.setProperty(
                "--zoom",
                (this.zoomLevel / 100).toString()
              );
              return;
            };
            this.renderer.appendChild(signatureId, resizer);
            rerenderSign();

            let startX, startY;
            let baseWidth;
            let baseHeight;
            const signatureWidth = (this.widthRectangle * this.zoomLevel) / 100;
            const heightRectangle =
              (this.heightRectangle * this.zoomLevel) / 100;
            const widthHeightRatio = signatureWidth / heightRectangle;

            this.renderer.listen(resizer, "mousedown", (e) => {
              e.stopPropagation();
              startX = e.clientX;
              startY = e.clientY;
              baseWidth = signatureId.offsetWidth;
              baseHeight = signatureId.offsetHeight;

              document.documentElement.addEventListener(
                "mousemove",
                doDragSignPosition
              );
              document.documentElement.addEventListener(
                "mouseup",
                stopDragSignPosition
              );
            });

            const doDragSignPosition = (e) => {
              e.stopPropagation();
              const signatureH =
                (this.signPosition.find((e) => e.id === sign.id).width *
                  this.zoomLevel) /
                100;
              const signatureW =
                (this.signPosition.find((e) => e.id === sign.id).width *
                  this.zoomLevel) /
                100;
              signatureId.style.width = signatureW + e.clientX - startX + "px";
              signatureId.style.height = signatureH + e.clientY - startY + "px";
              const widthHeightRatioDrag =
                signatureId.offsetWidth / signatureId.offsetHeight;
              if (widthHeightRatio !== widthHeightRatioDrag) {
                signatureId.style.height =
                  signatureId.offsetWidth / widthHeightRatio + "px";
                signatureId.style.width =
                  signatureId.offsetHeight * widthHeightRatio + "px";
              }
              signatureId.style.maxWidth =
                this.textLayerDiv.offsetWidth - signatureId.offsetLeft + "px";
              signatureId.style.maxHeight =
                this.textLayerDiv.offsetHeight - signatureId.offsetTop + "px";
              signatureId.innerHTML = this.generateStampContentWidthHeight(
                Number(signatureId.offsetWidth),
                Number(signatureId.offsetHeight),
                null,
                true
              );

              rerenderSign();
            };

            const stopDragSignPosition = (e) => {
              const wrapperLeft = (sign.x * this.zoomLevel) / 100;
              const wrapperTop = (sign.y * this.zoomLevel) / 100;
              e.stopPropagation();
              if (
                signatureId.offsetWidth / 2 + wrapperLeft < 0 ||
                signatureId.offsetHeight / 2 + wrapperTop < 0
              ) {
                signatureId.style.width = baseWidth + "px";
                signatureId.style.height = baseHeight + "px";
              } else {
                baseWidth = signatureId.offsetWidth;
                baseHeight = signatureId.offsetHeight;
              }
              signatureId.innerHTML = this.generateStampContentWidthHeight(
                Number(signatureId.offsetWidth),
                Number(signatureId.offsetHeight),
                null,
                true
              );

              this.signPosition = this.signPosition.map((position) => {
                if (position.id === sign.id && position.fileId === fileId) {
                  position.width = signatureId.offsetWidth;
                  position.height = signatureId.offsetHeight;
                }
                return position;
              });
              this.imageData = this.imageData.map((position) => {
                if (position.id === sign.id && position.fileId === fileId) {
                  position.widthRectangle = signatureId.offsetWidth;
                  position.heightRectangle = signatureId.offsetHeight;
                }
                return position;
              });
              rerenderSign();
              document.documentElement.removeEventListener(
                "mousemove",
                doDragSignPosition
              );
              document.documentElement.removeEventListener(
                "mouseup",
                stopDragSignPosition
              );
            };
          }
        }
      }
    }
  }

  renderFilePDF() {
    if (this.document) {
      const firstFile = this.document.mainContractAttachments[0];
      this.pdfSrc = this.listPdfSrc[firstFile.path];
      this.setTitleFilePDF();
    }
  }

  toggleFullviewPdf() {
    this.isFullviewPdf = !this.isFullviewPdf;
    this.setZoomLevel();
  }

  renderFilePDFAfterReloadPage() {
    if (!this.listPdfSrc) {
      this.listPdfSrc = {};
    }
    const firstFile = this.document.mainContractAttachments[0];
    this.handleRenderFilePDFAfterReloadPage(
      this.document.id,
      firstFile.path,
      firstFile.fileSize
    )
      .then((res) => {
        if (res) {
          // xong thằng đầu tiên
          this.pdfSrc = res;
          this.listPdfSrc[firstFile.path] = res;
          // xử lý các file tiếp theo
          for (const item of this.document.mainContractAttachments) {
            if (item.path != firstFile.path) {
              this.handleRenderFilePDFAfterReloadPage(
                this.document.id,
                item.path,
                item.fileSize
              );
            }
          }
          this.setTitleFilePDF();
        }
      })
      .catch((e) => {
        this.toastr.error("error");
      });
  }

  handleRenderFilePDFAfterReloadPage(contractId, pdfFilePath, size?) {
    return new Promise((resolve, reject) => {
      const data: ViewDocumentReferenceDto = {
        mainContractId: contractId,
        referenceContractId: "",
        pdfFilePath: pdfFilePath,
      };
      if (!this.env.pdfViewFullDownload && size && size > 10485760) {
        const queryString = Object.entries(data)
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join("&");
        const pdfSrc = `${this.BASE_URL}?${queryString}`;
        this.listPdfSrc[pdfFilePath] = pdfSrc;
        this.document.mainContractAttachments.forEach((item) => {
          if (item.path == pdfFilePath) {
            item.loading = false;
          }
        });
      } else {
        try {
          this.commonService
            .getViewPdfForDocumentByFilePath(data)
            .subscribe((res) => {
              this.blobToSrc(res)
                .then((res) => {
                  this.listPdfSrc[pdfFilePath] = res;
                  resolve(res);
                })
                .catch((e) => {
                  reject(e);
                });
            });
        } catch (e) {
          reject(e);
        }
      }
    });
  }

  setTitleFilePDF() {
    if (this.document && this.document.mainContractAttachments) {
      setTimeout(() => {
        const tabs = document.getElementsByClassName("tab");
        if (tabs) {
          Array.from({ length: tabs.length }, (v, i) => i).forEach((index) => {
            const tab = tabs.item(index) as HTMLElement;
            tab.style.width =
              100 / this.document.mainContractAttachments.length + "%";
          });
        }
      }, 100);
    }
  }

  blobToSrc(blob: any) {
    return new Promise((resolve, reject) => {
      try {
        const file = this.blobToFile(blob, "application/pdf");
        this.commonService.readFile(file, (pdfSrc) => {
          resolve(pdfSrc);
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  changeFile(filePath: string, index: number) {
    if (index === this.activeFile) {
      return;
    }
    this.isSelectedPosition.next(false);
    const nodeOther = document.getElementById("show-frames-notification");
    if (nodeOther) {
      nodeOther.remove();
    }
    this.pageCurrent = 1;
    this.activeFile = index;

    this.checkSignManual();

    if (this.listPdfSrc) {
      this.pdfSrc = this.listPdfSrc[filePath];
    }
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  checkFileNotHaveSign(id: string) {
    return this.fileError.includes(id);
  }

  setZoomLevel() {
    // TODO
    if (
      (this.mediaBreakpoint === SCREEN_SIZE.MD ||
        this.mediaBreakpoint === SCREEN_SIZE.LG ||
        this.mediaBreakpoint === SCREEN_SIZE.XL ||
        this.mediaBreakpoint === SCREEN_SIZE.XXL) &&
      this.isFullviewPdf
    ) {
      this.zoomLevel = 100;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.XXL) {
        this.zoomLevel = 100;
      } else if (
        this.mediaBreakpoint === SCREEN_SIZE.XL ||
        this.mediaBreakpoint === SCREEN_SIZE.LG
      ) {
        this.zoomLevel = 75;
      } else {
        this.zoomLevel = 50;
      }
    }
  }

  // ----------- render Chân ký ---------------

  // check
  checkSignManual() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter((sign) => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0) {
      this.isAllowSelectSignPosition = false;
      this.isSelectedPosition.next(false);
      if (
        signs.length === 1 &&
        signs[0].signType === this.signPositionTypes.DIGITAL
      ) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
    } else {
      this.isAllowSelectSignPosition = true;
      this.onStamped();
    }
  }

  checkSignManualNoStamp() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter((sign) => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0) {
      this.isAllowSelectSignPosition = false;
      this.isSelectedPosition.next(false);
      if (
        signs.length === 1 &&
        signs[0].signType === this.signPositionTypes.DIGITAL
      ) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
    } else {
      this.isAllowSelectSignPosition = true;
    }
  }

  // Đặt lại chân ký
  onStamped() {
    this.isSelectedPosition.next(true);
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    if (fileId && this.signPosition && this.signPosition.length > 0) {
      this.signPosition = this.signPosition.filter((sign) => {
        return sign.fileId !== fileId;
      });
    }
    if (fileId && this.imageData && this.imageData.length > 0) {
      this.imageData = this.imageData.filter((image) => {
        return image.fileId !== fileId;
      });
    }
    const listElement = document.getElementsByClassName("box-sign");
    if (listElement && listElement.length) {
      listElement.item(0).remove();
    }
    const nodeOther = document.getElementById("show-frames-notification");
    if (nodeOther) {
      nodeOther.remove();
    }
    this.showFramesNotification();
  }

  // Khung hiển thị chân ký
  showFramesNotification() {
    const nodeOther = document.getElementById("show-frames-notification");
    if (nodeOther) {
      nodeOther.remove();
    }
    const navBoundingClient =
      this.navigation.nativeElement.getBoundingClientRect();
    const { top, left, bottom, width, height } = navBoundingClient;
    const signatureWidth = (this.widthRectangle * this.zoomLevel) / 100;
    const heightRectangle = (this.heightRectangle * this.zoomLevel) / 100;
    const navigation = document.getElementById("navigation");
    const newTop = top - 2 * heightRectangle;
    const newLeft = width / 2 - signatureWidth / 2;
    const stampNode = document.createElement("div");
    this.renderer.setAttribute(stampNode, "id", "show-frames-notification");
    const contentNode = `<span style="color: red;">${this.translateService.instant(
      "messages.click_to_select_sign_position"
    )}</span>`;
    stampNode.innerHTML = contentNode;
    this.renderer.setStyle(stampNode, "position", "absolute");
    this.renderer.setStyle(stampNode, "background", "rgb(0,0,0,0.2)");
    this.renderer.setStyle(stampNode, "left", `${newLeft}px`);
    this.renderer.setStyle(stampNode, "top", `${newTop}px`);
    this.renderer.setStyle(stampNode, "width", `${signatureWidth}px`);
    this.renderer.setStyle(stampNode, "height", `${heightRectangle}px`);
    this.renderer.setStyle(stampNode, "zIndex", 1);
    this.renderer.setStyle(stampNode, "border", "1px solid #999999");
    this.renderer.setStyle(stampNode, "display", "flex");
    this.renderer.setStyle(stampNode, "alignItems", "center");
    this.renderer.setStyle(stampNode, "justifyContent", "center");

    this.stampWrapper = stampNode;
    navigation.appendChild(stampNode);
  }

  textLayerRendered(ele) {
    if (this.isShowPdf) {
      this.checkSignManualNoStamp();
      if (this.isSignDigitalCertificate && !this.isShowImage) {
        return "";
      }
      const element = ele.source.textLayerDiv;
      this.textLayerDiv = element;
      const pageIndex = ele.source.pageNumber;
      this.renderer.listen(element, "mouseenter", () => {
        this.pageIndex = pageIndex;
      });

      let signPosition;
      const fileId = this.document.mainContractAttachments[this.activeFile].id;
      const id = this.decodeId(fileId);
      const imageId = this.commonService.generateUUID();

      // lấy các chữ ký từng pageNumber nếu đã cấu hình sẵn chân ký
      if (this.signPosition && this.signPosition.length > 0) {
        signPosition = this.signPosition.filter((item) => {
          return item.pageNumber === pageIndex && id === item.fileId;
        });
      }

      if (signPosition && signPosition.length > 0) {
        for (const position of signPosition) {
          const x = position.x;
          const y = position.y;
          const _width = position.width;
          const _height = position.height;
          const signType = position.signType;
          const id = position.id;
          const htmlNode = this.getStampWrapper(
            x,
            y,
            signType,
            id,
            element,
            parseInt(position.page)
          );
          const hasImage = this.signPosition.some(
            (e) => e.signType === SignPositionTypes.IMAGE
          );
          if (signType === SignPositionTypes.DIGITAL && hasImage) {
            // Lọc lấy những SignPosition có signType là 'image'
            console.log("not show digital");
          } else {
            this.renderer.appendChild(element, htmlNode);
          }
        }

        // move đến trang chân ký lần vào đầu tiên
        if (this.isGotoSignpage) {
          const firstPosition = signPosition[0];
          const firstPage = firstPosition.pageNumber;
          this.signPage = firstPosition.pageNumber;
          this.gotoSignPageNumber(firstPage);
          this.isGotoSignpage = false;
        }
        const fileCustomerSign = this.signPosition.find(
          (sign) => sign.fileId === id && sign.isNew
        );
        this.isAllowSelectSignPosition = !!fileCustomerSign;
        this.isSelectedPosition.next(false);
      }

      // Luồng đặt chân ký
      if (this.isAllowSelectSignPosition) {
        // kéo chân ký ra khỏi file PDF
        this.renderer.listen(element, "mouseleave", () => {
          if (this.isSelectedPosition.getValue()) {
            const nodeOther = document.getElementById(
              "show-frames-notification"
            );
            if (nodeOther) {
              nodeOther.remove();
            }
          }
        });

        // event lăn chân ký sang file khác
        this.renderer.listen(element, "wheel", (wheelEvent) => {
          if (this.isSelectedPosition.getValue()) {
            const node = element.querySelector("#show-frames-notification");
            const nodeOther = document.getElementById(
              "show-frames-notification"
            );
            if (!node && nodeOther) {
              nodeOther.remove();
            }
            const boundingClient = element.getBoundingClientRect();
            const { top, left } = boundingClient;
            const signatureWidth = (this.widthRectangle * this.zoomLevel) / 100;
            const heightRectangle =
              (this.heightRectangle * this.zoomLevel) / 100;

            if (!node) {
              const stampNode = this.renderer.createElement("div");
              stampNode.innerHTML = this.generateStampContent();
              this.stampWrapper = stampNode;
              this.renderer.setAttribute(
                stampNode,
                "id",
                "show-frames-notification"
              );
              const width = signatureWidth;
              const height = heightRectangle;
              const wrapperLeft =
                wheelEvent.clientX - signatureWidth / 2 - left;
              const wrapperTop = wheelEvent.clientY - heightRectangle / 2 - top;
              this.setStyleFrameSignature(
                stampNode,
                width,
                height,
                wrapperLeft,
                wrapperTop
              );
              this.renderer.appendChild(element, stampNode);
            } else {
              this.renderer.setStyle(
                node,
                "left",
                `${wheelEvent.clientX - signatureWidth / 2 - left}px`
              );
              this.renderer.setStyle(
                node,
                "top",
                `${wheelEvent.clientY - heightRectangle / 2 - top}px`
              );
            }
          }
        });

        // đặt chân ký
        this.renderer.listen(element, "mousedown", (mousedownEvent) => {
          if (this.isSelectedPosition.getValue()) {
            this.isSelectedPosition.next(false);
            const framesNotification = document.getElementById(
              "show-frames-notification"
            );
            if (framesNotification) {
              framesNotification.remove();
            }
            const offsetParent = element.offsetParent.dataset;
            const { pageNumber } = offsetParent;
            const boundingClient = element.getBoundingClientRect();
            const { top, left } = boundingClient;
            const signatureWidth = (this.widthRectangle * this.zoomLevel) / 100;
            const heightRectangle =
              (this.heightRectangle * this.zoomLevel) / 100;
            const signZoom = this.zoomLevel / 100;
            const widthHeightRatio = signatureWidth / heightRectangle;
            const wrapperLeft =
              mousedownEvent.clientX - signatureWidth / 2 - left;
            const wrapperTop =
              mousedownEvent.clientY - heightRectangle / 2 - top;

            this.setStyleFrameSignature(
              this.stampWrapper,
              signatureWidth,
              heightRectangle,
              wrapperLeft,
              wrapperTop
            );
            this.stampWrapper.innerHTML = this.generateStampContent();

            if (this.canMoveAndResize) {
              let startX, startY;
              let baseWidth;
              let baseHeight;
              const resizer = this.renderer.createElement("div");
              this.renderer.setAttribute(
                resizer,
                "class",
                "resize-div-bot-right"
              );
              resizer.style.setProperty("--zoom", signZoom.toString());
              const rerenderSign = () => {
                this.stampWrapper.appendChild(resizer);
                resizer.style.removeProperty("--zoom");
                resizer.style.setProperty("--zoom", signZoom.toString());
                return;
              };
              this.renderer.appendChild(this.stampWrapper, resizer);

              this.renderer.listen(resizer, "mousedown", (e) => {
                e.stopPropagation();
                startX = e.clientX;
                startY = e.clientY;
                baseWidth = this.stampWrapper.offsetWidth;
                baseHeight = this.stampWrapper.offsetHeight;
                document.documentElement.addEventListener(
                  "mousemove",
                  doDragSignPosition
                );
                document.documentElement.addEventListener(
                  "mouseup",
                  stopDragSignPosition
                );
              });

              const doDragSignPosition = (e) => {
                e.stopPropagation();
                const positionData = this.signPosition.find(
                  (sign) => sign.id === imageId
                );
                const signatureH = (positionData.width * this.zoomLevel) / 100;
                const signatureW = (positionData.width * this.zoomLevel) / 100;
                this.stampWrapper.style.width =
                  signatureW + e.clientX - startX + "px";
                this.stampWrapper.style.height =
                  signatureH + e.clientY - startY + "px";
                const widthHeightRatioDrag =
                  this.stampWrapper.offsetWidth /
                  this.stampWrapper.offsetHeight;
                if (widthHeightRatio !== widthHeightRatioDrag) {
                  this.stampWrapper.style.height =
                    this.stampWrapper.offsetWidth / widthHeightRatio + "px";
                  this.stampWrapper.style.width =
                    this.stampWrapper.offsetHeight * widthHeightRatio + "px";
                }
                this.stampWrapper.style.maxWidth =
                  element.offsetWidth - this.stampWrapper.offsetLeft + "px";
                this.stampWrapper.style.maxHeight =
                  element.offsetHeight - this.stampWrapper.offsetTop + "px";
                this.stampWrapper.innerHTML =
                  this.generateStampContentWidthHeight(
                    Number(this.stampWrapper.offsetWidth),
                    Number(this.stampWrapper.offsetHeight),
                    null,
                    true
                  );

                rerenderSign();
              };
              const stopDragSignPosition = (e) => {
                e.stopPropagation();
                if (
                  this.stampWrapper.offsetWidth / 2 + wrapperLeft < 0 ||
                  this.stampWrapper.offsetHeight / 2 + wrapperTop < 0
                ) {
                  this.stampWrapper.style.width = baseWidth + "px";
                  this.stampWrapper.style.height = baseHeight + "px";
                } else {
                  baseWidth = this.stampWrapper.offsetWidth;
                  baseHeight = this.stampWrapper.offsetHeight;
                }
                this.stampWrapper.innerHTML =
                  this.generateStampContentWidthHeight(
                    Number(this.stampWrapper.offsetWidth),
                    Number(this.stampWrapper.offsetHeight),
                    null,
                    true
                  );
                this.signPosition = this.signPosition.map((position) => {
                  if (position.id === imageId && position.fileId === id) {
                    position.width = this.stampWrapper.offsetWidth;
                    position.height = this.stampWrapper.offsetHeight;
                  }
                  return position;
                });
                this.imageData = this.imageData.map((position) => {
                  if (position.id === imageId && position.fileId === id) {
                    position.widthRectangle = this.stampWrapper.offsetWidth;
                    position.heightRectangle = this.stampWrapper.offsetHeight;
                  }
                  return position;
                });
                rerenderSign();
                document.documentElement.removeEventListener(
                  "mousemove",
                  doDragSignPosition
                );
                document.documentElement.removeEventListener(
                  "mouseup",
                  stopDragSignPosition
                );
              };
            }
            this.renderer.appendChild(element, this.stampWrapper);

            // xoá dòng thông báo click để chọn vị trí
            document.querySelectorAll("#notify_outside").forEach((item) => {
              if (item) {
                item.remove();
              }
            });

            const zoomLevel = this.zoomLevel;
            this.imageData = this.imageData.filter((img) => {
              return img.fileId !== fileId;
            });
            this.imageData.push({
              stampPositionLeft:
                mousedownEvent.clientX - signatureWidth / 2 - left,
              stampPositionTop:
                mousedownEvent.clientY - heightRectangle / 2 - top,
              positionX: (100 * wrapperLeft) / zoomLevel,
              positionY: (100 * wrapperTop) / zoomLevel,
              pageIndex,
              zoom: this.zoomLevel / 100,
              pdfSrc: this.pdfSrc,
              pageNumber,
              id: imageId,
              isNew: true,
              signType: SignPositionTypes.COMBINE,
              type: SignDocumentComponent.SIGN_SINGLE,
              widthRectangle: this.widthRectangle,
              heightRectangle: this.heightRectangle,
              fileId: id,
            });
            this.signPosition = this.signPosition.filter((sp) => {
              return sp.fileId !== id;
            });
            this.signPosition.push({
              fileId: id,
              signType: SignPositionTypes.COMBINE,
              pageNumber: Number(pageIndex),
              x: (100 * wrapperLeft) / zoomLevel,
              y: (100 * wrapperTop) / zoomLevel,
              width: this.widthRectangle,
              height: this.heightRectangle,
              id: imageId,
              isNew: true,
            });
            if (this.fileError.includes(fileId)) {
              this.fileError = this.fileError.filter((idFile) => {
                return idFile !== fileId;
              });
            }
          }
        });

        // Di chuyển chân ký
        this.renderer.listen(element, "mousemove", (mousemoveEvent) => {
          if (this.isSelectedPosition.getValue()) {
            const node = element.querySelector("#show-frames-notification");
            const nodeOther = document.getElementById(
              "show-frames-notification"
            );
            if (!node && nodeOther) {
              nodeOther.remove();
            }
            const boundingClient = element.getBoundingClientRect();
            const { top, left } = boundingClient;
            const signatureWidth = (this.widthRectangle * this.zoomLevel) / 100;
            const heightRectangle =
              (this.heightRectangle * this.zoomLevel) / 100;
            if (!node) {
              const stampNode = this.renderer.createElement("div");
              stampNode.innerHTML = this.generateStampContent();
              this.renderer.setAttribute(
                stampNode,
                "id",
                "show-frames-notification"
              );
              const width = signatureWidth;
              const height = heightRectangle;
              const wrapperLeft =
                mousemoveEvent.clientX - signatureWidth / 2 - left;
              const wrapperTop =
                mousemoveEvent.clientY - heightRectangle / 2 - top;
              this.setStyleFrameSignature(
                stampNode,
                width,
                height,
                wrapperLeft,
                wrapperTop
              );

              this.renderer.appendChild(element, stampNode);
            } else {
              this.renderer.setStyle(
                node,
                "left",
                `${mousemoveEvent.clientX - signatureWidth / 2 - left}px`
              );
              this.renderer.setStyle(
                node,
                "top",
                `${mousemoveEvent.clientY - heightRectangle / 2 - top}px`
              );
            }
          }
        });
      }

      this.renderer.setStyle(element, "opacity", "1");
      this.renderer.setAttribute(element, "id", `text-pdf-layer-${pageIndex}`);
      this.pageIndex++;
      if (
        this.isAllowSelectSignPosition &&
        this.isSelectedPosition.getValue()
      ) {
        this.onStamped();
      }
    }
  }

  // Add style khung chân ký
  setStyleFrameSignature(
    stampNode: any,
    widthRectangle: number,
    heightRectangle: number,
    wrapperLeft: number,
    wrapperTop: number
  ) {
    this.renderer.setStyle(stampNode, "position", "absolute");
    this.renderer.setStyle(stampNode, "background", "rgb(0,0,0,0.2)");
    this.renderer.setStyle(stampNode, "zIndex", 1);
    this.renderer.setStyle(stampNode, "border", "1px solid #999999");
    this.renderer.setStyle(stampNode, "lineHeight", "1.9");
    this.renderer.setStyle(stampNode, "color", "#00f");
    this.renderer.setStyle(
      stampNode,
      "fontFamily",
      '"Times New Roman", Times, serif'
    );
    this.renderer.setStyle(stampNode, "left", `${wrapperLeft}px`);
    this.renderer.setStyle(stampNode, "top", `${wrapperTop}px`);
    this.renderer.setStyle(stampNode, "width", `${widthRectangle}px`);
    this.renderer.setStyle(stampNode, "height", `${heightRectangle}px`);
    this.renderer.setStyle(
      stampNode,
      "padding",
      `${(10 * this.zoomLevel) / 100}px`
    );
    this.renderer.setStyle(
      stampNode,
      "fontSize",
      `${(16 * this.zoomLevel) / 100}px`
    );
    this.renderer.setStyle(stampNode, "display", "flex");
    this.renderer.setStyle(stampNode, "alignItems", "center");
    this.renderer.setStyle(stampNode, "justifyContent", "center");
  }

  // lấy khung chân ký
  getStampWrapper(
    positionX: number,
    positionY: number,
    signType: string,
    id: string,
    elementTextLayerDiv: any,
    basePageIndex: number
  ) {
    const signPositionData = this.signPosition.find((e) => e.id === id);
    const width = signPositionData.width;
    const height = signPositionData.height;
    const stampNode = this.renderer.createElement("div");
    this.renderer.setAttribute(stampNode, "id", `sign-${id}`);

    // with, height khung ký
    let widthRectangle = (width * this.zoomLevel) / 100;
    const heightRectangle = (height * this.zoomLevel) / 100;

    // khoảng cách từ lề trái, lề bên trên đến chân ký
    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;

    const widthHeightRatio = width / height;

    // lấy vị trí tương đối của elementTextLayerDiv
    let { top, left } = elementTextLayerDiv.getBoundingClientRect();

    const elementId = elementTextLayerDiv.id.replace("text-pdf-layer-", "");

    // Add style cho khung chân ký
    this.setStyleFrameSignature(
      stampNode,
      widthRectangle,
      heightRectangle,
      wrapperLeft,
      wrapperTop
    );

    stampNode.innerHTML = this.generateStampContentWidthHeight(
      width,
      height,
      signType,
      !!signPositionData.isNew
    );
    stampNode.className = "box-sign";

    // move chân ký
    if (this.canMoveAndResize) {
      // move element
      let baseWrapperLeft;
      let baseWrapperTop;
      let signId;
      if (!signPositionData.isNew) {
        stampNode.style.cursor = "move";
        stampNode.addEventListener("mousedown", (e) => {
          const targetSignId = e.target as Element;
          signId = targetSignId.id.replace("sign-", "");
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
          stampNode.innerHTML = `<div style="font-size: ${
            16 * signZoom
          }px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
              <div id="notify_outside" style="position: absolute;top: -${
                35 * signZoom
              }px;left: ${
            (stampNode.offsetWidth / 2 - 150) * signZoom
          }px;color: red; width: ${
            300 * signZoom
          }px">${this.translateService.instant(
            "messages.click_to_select_sign_position"
          )}</div>
                ${this.generateStampContentWidthHeight(
                  stampNode.offsetWidth,
                  stampNode.offsetHeight,
                  signType,
                  !!signPositionData.isNew
                )}
              </div>`;

          document.documentElement.addEventListener("mousemove", doMove);
          document.documentElement.addEventListener("wheel", (wheelEvent) => {
            const elBounding = elementTextLayerDiv.getBoundingClientRect();
            left = elBounding.left;
            top = elBounding.top;
          });
          document.documentElement.addEventListener("mouseup", stopMove);
        });
      }
      const signZoom = this.zoomLevel / 100;
      let goPage;
      // Move element sign
      const doMove = (e) => {
        goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`);
        if (this.pageIndex + "" !== elementId && goPage) {
          const elBounding = goPage.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        } else {
          const elBounding = elementTextLayerDiv.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        }
        stampNode.style.left =
          e.clientX - stampNode.offsetWidth / 2 - left + "px";
        stampNode.style.top =
          e.clientY - stampNode.offsetHeight / 2 - top + "px";
      };

      // stop move and save position
      const stopMove = (e) => {
        e.stopPropagation();
        if (
          stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0 ||
          stampNode.offsetHeight / 2 + stampNode.offsetTop < 0
        ) {
          stampNode.style.left = baseWrapperLeft + "px";
          stampNode.style.top = baseWrapperTop + "px";
          this.pageIndex = basePageIndex;
        } else {
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
        }
        stampNode.innerHTML = this.generateStampContentWidthHeight(
          stampNode.offsetWidth,
          stampNode.offsetHeight,
          signType,
          !!signPositionData.isNew
        );
        this.signPosition = this.signPosition.map((position) => {
          if (position.id === id && position.fileId === fileId) {
            position.x = stampNode.offsetLeft / signZoom;
            position.y = stampNode.offsetTop / signZoom;
            position.pageNumber = this.pageIndex;
          }
          return position;
        });
        this.imageData = this.imageData.map((position) => {
          if (position.id === id && position.fileId === fileId) {
            position.positionX = stampNode.offsetLeft / signZoom;
            position.positionY = stampNode.offsetTop / signZoom;
            position.pageIndex = this.pageIndex;
            position.pageNumber = this.pageIndex;
          }
          return position;
        });
        rerenderSign();
        document.documentElement.removeEventListener("mousemove", doMove);
        document.documentElement.removeEventListener("mouseup", stopMove);
      };
      const fileId = this.decodeId(
        this.document.mainContractAttachments[this.activeFile].id
      );
      const resizer = document.createElement("div");
      resizer.setAttribute("class", "resize-div-bot-right");
      resizer.style.setProperty("--zoom", signZoom.toString());
      const rerenderSign = () => {
        stampNode.appendChild(resizer);
        resizer.style.removeProperty("--zoom");
        resizer.style.setProperty("--zoom", signZoom.toString());
        return;
      };
      if (signType !== SignPositionTypes.DIGITAL) {
        stampNode.appendChild(resizer);

        let startX, startY;
        let baseWidth;
        let baseHeight;
        resizer.addEventListener("mousedown", (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          const targetSignId = e.target as Element;
          signId = targetSignId.parentElement.id.replace("sign-", "");
          baseWidth = stampNode.offsetWidth;
          baseHeight = stampNode.offsetHeight;
          document.documentElement.addEventListener("mousemove", doDrag);
          document.documentElement.addEventListener("mouseup", stopDrag);
        });

        const doDrag = (e) => {
          e.stopPropagation();
          const signatureHeight =
            (signPositionData.height * this.zoomLevel) / 100;
          stampNode.style.width =
            (signPositionData.width * this.zoomLevel) / 100 +
            e.clientX -
            startX +
            "px";
          stampNode.style.height = signatureHeight + e.clientY - startY + "px";
          const widthHeightRatioDrag =
            stampNode.offsetWidth / stampNode.offsetHeight;
          if (widthHeightRatio !== widthHeightRatioDrag) {
            stampNode.style.height =
              stampNode.offsetWidth / widthHeightRatio + "px";
            stampNode.style.width =
              stampNode.offsetHeight * widthHeightRatio + "px";
          }
          stampNode.style.maxWidth =
            elementTextLayerDiv.offsetWidth - stampNode.offsetLeft + "px";
          stampNode.style.maxHeight =
            elementTextLayerDiv.offsetHeight - stampNode.offsetTop + "px";
          stampNode.innerHTML = this.generateStampContentWidthHeight(
            Number(stampNode.offsetWidth),
            Number(stampNode.offsetHeight),
            signType,
            !!signPositionData.isNew
          );

          rerenderSign();
        };

        const stopDrag = (e) => {
          e.stopPropagation();
          if (
            stampNode.offsetWidth / 2 + wrapperLeft < 0 ||
            stampNode.offsetHeight / 2 + wrapperTop < 0
          ) {
            console.log("");
          } else {
            baseWidth = stampNode.offsetWidth;
            baseHeight = stampNode.offsetHeight;
          }
          stampNode.innerHTML = this.generateStampContentWidthHeight(
            Number(stampNode.offsetWidth),
            Number(stampNode.offsetHeight),
            signType,
            !!signPositionData.isNew
          );
          this.signPosition = this.signPosition.map((position) => {
            if (position.id === id && position.fileId === fileId) {
              position.width = stampNode.offsetWidth;
              position.height = stampNode.offsetHeight;
            }
            return position;
          });
          this.imageData = this.imageData.map((position) => {
            if (position.id === id && position.fileId === fileId) {
              position.widthRectangle = stampNode.offsetWidth;
              position.heightRectangle = stampNode.offsetHeight;
            }
            return position;
          });
          rerenderSign();
          document.documentElement.removeEventListener("mousemove", doDrag);
          document.documentElement.removeEventListener("mouseup", stopDrag);
        };
      }
      //    resize element
    }
    return stampNode;
  }

  // generate chữ ký Resize
  generateStampContentWidthHeight(
    widthRect: number,
    heightRect: number,
    signType: string,
    canNotMove: boolean
  ): string {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = widthRect * zoom;
    let heightRectangle = heightRect * zoom;
    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;
    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }
    const heightPx = `${height}px`;
    const widthPx = `${width}px`;

    this.cd.detectChanges();
    if (this.fileUpload || !this.isDisplaySignatureTab(1)) {
      if (signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      } else {
        if (this.systemImageSign) {
          contentNode = `
                        <i class="fa fa-undo" aria-hidden="true"
                            style="
                                display: ${
                                  this.canMoveAndResize && !canNotMove
                                    ? ""
                                    : "none"
                                };
                                font-size: ${15 * zoom}px;
                                position: absolute; top: 5px; right: 5px;
                                cursor: move;
                                height: unset;
                                width: unset;
                                color: red;
                                z-index: 100;">
                            </i>
                        <img draggable="false"
                            src="${this.imageUrlPreview}"
                            style="
                                transform: scale(${
                                  this.signConfig.signaturePosition.value ===
                                    "top" ||
                                  this.signConfig.signaturePosition.value ===
                                    "bottom"
                                    ? (heightRectangle + 20) /
                                      this.heightImageRender
                                    : (widthRectangle + 20) /
                                      this.widthImageRender
                                });
                                display: flex;
                                justify-content: flex-end;
                                align-items:
                                flex-start;
                                object-fit: cover;"/>
                     `;
        } else {
          if (this.imageUrlPreview) {
            contentNode = `
                        <i class="fa fa-undo" aria-hidden="true"
                            style="
                                display: ${
                                  this.canMoveAndResize && !canNotMove
                                    ? ""
                                    : "none"
                                };font-size: ${15 * zoom}px;
                                position: absolute; top: 5px; right: 5px;
                                cursor: move;
                                height: unset;
                                width: unset;
                                color: red;
                                z-index: 100;">
                            </i>
                            <img draggable="false"
                                src="${this.imageUrlPreview}"
                                style="
                                    height: ${heightPx};
                                    width: ${widthPx};
                                    max-width: ${
                                      this.signConfig.signaturePosition
                                        .value === "left" ||
                                      this.signConfig.signaturePosition
                                        .value === "right"
                                        ? "1386px"
                                        : "none"
                                    }; max-height: ${
              this.signConfig.signaturePosition.value === "top" ||
              this.signConfig.signaturePosition.value === "bottom"
                ? "538px"
                : "none"
            };
                                    margin: auto;
                                    display: flex;
                                    justify-content:
                                    flex-end;
                                    align-items: flex-start;"/>
                              `;
          } else {
            contentNode = `
                        <i class="fa fa-undo" aria-hidden="true"
                            style="
                                display: ${
                                  this.canMoveAndResize && !canNotMove
                                    ? ""
                                    : "none"
                                };font-size: ${15 * zoom}px;
                                position: absolute; top: 5px; right: 5px;
                                cursor: move;
                                height: unset;
                                width: unset;
                                color: red;
                                z-index: 100;">
                            </i>
                            <div style="color: #EE0033; text-align: center;">
                                ${this.translateService.instant(
                                  "enterprise_contract.image_signing.no_image.no_select_image_signature"
                                )}
                            </div>
                              `;
          }
        }
      }
    } else {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter((sign) => {
        return sign.fileId === fileId;
      });
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP &&
        ((signs && signs.length > 0) || (signs && signs.length === 0))
      ) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
                    <div>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_by"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_by"
                              )
                        } ${this.enterpriseName}
                        <br/>
                        ${this.translateService.instant(
                          "enterprise_contract.image_signing.no_image.signed_phone"
                        )} ${this.selectedCert.phoneNumber}
                        <br/>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_date"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_date"
                              )
                        } ${this.dateNow}
                        ${this.isNotAttestedUser ? "" : "<br/>"}
                        ${
                          this.isNotAttestedUser
                            ? ""
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.verified_info"
                              )
                        }
                      </div>
                    `;
        }
      } else if (
        this.selectedCert.typeCertificate ===
          this.enumSignMethod.SIGN_NO_CERT &&
        ((signs.length && signs.length > 0) || (signs && signs.length === 0))
      ) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
                    <div>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_by"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_by"
                              )
                        } ${this.enterpriseName}
                          <br/>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_date"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_date"
                              )
                        } ${this.dateNow}
                        ${this.isNotAttestedUser ? "" : "<br/>"}
                        ${
                          this.isNotAttestedUser
                            ? ""
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.verified_info"
                              )
                        }
                     </div>
                  `;
        }
      } else if ((signs && signs.length > 1) || (signs && signs.length === 0)) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `<div>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_by"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_by"
                              )
                        } ${this.selectedCert.issuedTo}
                      <br/>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_date"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_date"
                              )
                        } ${this.dateNow}
                    </div>`;
        }
      } else if (
        signs &&
        signs.length === 1 &&
        signs[0].signType === SignPositionTypes.DIGITAL
      ) {
        contentNode = `<div></div>`;
      } else if (
        signs &&
        signs.length === 1 &&
        signs[0].signType !== SignPositionTypes.DIGITAL
      ) {
        contentNode = `
                    <div>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_by"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_by"
                              )
                        } ${this.selectedCert.issuedTo}
                      <br/>
                        ${
                          this.isSignDigitalCertificate
                            ? this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.approver_date"
                              )
                            : this.translateService.instant(
                                "enterprise_contract.image_signing.no_image.signed_date"
                              )
                        } ${this.dateNow}
                    </div>`;
      }
    }

    return contentNode;
  }

  // generate chữ ký origin
  generateStampContent() {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = this.widthRectangle * zoom;
    let heightRectangle = this.heightRectangle * zoom;

    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;

    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }

    const heightPx = `${height}px`;
    const widthPx = `${width}px`;
    if (this.fileUpload || !this.isDisplaySignatureTab(1)) {
      let contentInsideNode = "";
      if (this.systemImageSign) {
        contentInsideNode = `
                    <img draggable="false" src="${
                      this.imageUrlPreview
                    }" style="transform: scale(${
          this.signConfig.signaturePosition.value === "top" ||
          this.signConfig.signaturePosition.value === "bottom"
            ? (heightRectangle + 20) / this.heightImageRender
            : (widthRectangle + 20) / this.widthImageRender
        }); display: flex; justify-content: flex-end; align-items: flex-start; object-fit: cover;"/>
             `;
      } else {
        if (this.imageUrlPreview) {
          contentInsideNode = `
                        <img draggable="false" src="${
                          this.imageUrlPreview
                        }" style="height: ${heightPx};width: ${widthPx}; max-width: ${
            this.signConfig.signaturePosition.value === "left" ||
            this.signConfig.signaturePosition.value === "right"
              ? "1386px"
              : "none"
          }; max-height: ${
            this.signConfig.signaturePosition.value === "top" ||
            this.signConfig.signaturePosition.value === "bottom"
              ? "538px"
              : "none"
          }; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                      `;
        } else {
          contentInsideNode = `
                    <div style="color: #EE0033; text-align: center;">
                        ${this.translateService.instant(
                          "enterprise_contract.image_signing.no_image.no_select_image_signature"
                        )}
                    </div>
                    `;
        }
      }
      // tslint:disable-next-line:max-line-length
      contentNode = `
                     <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant(
                       "messages.click_to_select_sign_position"
                     )}</div>
                     ${contentInsideNode}
                      `;
    } else {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter((sign) => {
        return sign.fileId === fileId;
      });
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP &&
        ((signs &&
          signs.length > 0 &&
          signs[0].signType !== SignPositionTypes.DIGITAL) ||
          (signs && signs.length === 0))
      ) {
        contentNode = `
          <div>
                <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant(
                  "messages.click_to_select_sign_position"
                )}</div>
                    ${
                      this.isSignDigitalCertificate
                        ? this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.approver_by"
                          )
                        : this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.signed_by"
                          )
                    } ${this.enterpriseName}
                  <br/>
                  ${this.translateService.instant(
                    "enterprise_contract.image_signing.no_image.signed_phone"
                  )} ${this.selectedCert.phoneNumber}
                  <br/>
                    ${
                      this.isSignDigitalCertificate
                        ? this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.approver_date"
                          )
                        : this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.signed_date"
                          )
                    } ${this.dateNow}
                  ${this.isNotAttestedUser ? "" : "<br/>"}
                  ${
                    this.isNotAttestedUser
                      ? ""
                      : this.translateService.instant(
                          "enterprise_contract.image_signing.no_image.verified_info"
                        )
                  }
                </div>
          `;
      } else if (
        (this.selectedCert.typeCertificate ===
          this.enumSignMethod.SIGN_NO_CERT ||
          this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_EKYC ||
          this.selectedCert.typeCertificate ===
            this.enumSignMethod.SIGN_EKYC_ADVANCED) &&
        ((signs &&
          signs.length > 0 &&
          signs[0].signType !== SignPositionTypes.DIGITAL) ||
          (signs && signs.length === 0))
      ) {
        contentNode = `
            <div>
                   <div id="notify_outside" style="position: absolute;top: -40px;left: 60px;color: red;">${this.translateService.instant(
                     "messages.click_to_select_sign_position"
                   )}</div>
                    ${
                      this.isSignDigitalCertificate
                        ? this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.approver_by"
                          )
                        : this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.signed_by"
                          )
                    } ${this.enterpriseName}
                  <br/>
                    ${
                      this.isSignDigitalCertificate
                        ? this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.approver_date"
                          )
                        : this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.signed_date"
                          )
                    } ${this.dateNow}
                  ${this.isNotAttestedUser ? "" : "<br/>"}
                  ${
                    this.isNotAttestedUser
                      ? ""
                      : this.translateService.instant(
                          "enterprise_contract.image_signing.no_image.verified_info"
                        )
                  }
             </div>
          `;
      } else if (
        (signs &&
          signs.length > 0 &&
          signs[0].signType !== SignPositionTypes.DIGITAL) ||
        (signs && signs.length === 0)
      ) {
        contentNode = `<div>
                  <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant(
                    "messages.click_to_select_sign_position"
                  )}</div>
                    ${
                      this.isSignDigitalCertificate
                        ? this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.approver_by"
                          )
                        : this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.signed_by"
                          )
                    } ${this.selectedCert.issuedTo}
                  <br/>
                    ${
                      this.isSignDigitalCertificate
                        ? this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.approver_date"
                          )
                        : this.translateService.instant(
                            "enterprise_contract.image_signing.no_image.signed_date"
                          )
                    } ${this.dateNow}
                </div>`;
      } else if (
        signs &&
        signs.length === 1 &&
        signs[0].signType === SignPositionTypes.DIGITAL
      ) {
        contentNode = `<div></div>`;
      }
    }
    return contentNode;
  }

  gotoSignPageNumber(signPage: number) {
    this.pageCurrent = signPage;
  }

  async convertHtmlToImage() {
    let imgUrl = "";
    let file = null;
    try {
      const imageSize = this.setSizeFrameImage();
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP &&
        this.scopeType !== 2
      ) {
        this.signConfig.confirmBy.enabled = true;
      } else {
        this.signConfig.confirmBy.enabled = false;
        delete this.signConfig.phoneNumber;
      }
      const rs = await this.imageGenerateService
        .genImage(this.signConfig, imageSize)
        .toPromise();
      file = new File([rs], "signatureImage.png", { type: "image/png" });
      imgUrl = (await this.commonService.getBase64(file)) as string;
    } catch (e) {
      console.log("call api error, use html to image", e);
      // this.blockUI.start('');
      const imageFile = await htmlToImage.toBlob(
        this.domRenderImage.nativeElement
      );
      file = new File([imageFile], "signatureImage.png", { type: "image/png" });
      imgUrl = await htmlToImage.toPng(this.domRenderImage.nativeElement);
    }

    this.fileUpload = file;
    this.signatureImageDefault = imgUrl;
    this.signatureFileDefault = file;

    this.setFontSize(imageConfigViewScaleId);
    this.setFontSize(imageConfigRenderId);
    setTimeout(() => {
      this.documentService.setImageSignature({
        url: imgUrl,
        fileUpload: file,
      });
    }, 100);
    // this.blockUI.stop();
    if (this.fileUpload) {
      this.handlePreviewFromFileUpload(this.fileUpload);
    }
  }

  // -----------------------------------------------------------

  // end fn group with PDF

  // start fn group sign
  async checkTimestampMoney(tmpl?: TemplateRef<any>) {
    // ----------------------- Validate PTK ------------------------
    // check connect plugins with USB token
    if (
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_USB_TOKEN
    ) {
      // check connect plugins
      this.blockUI.start("");
      await checkPlugin(this);
    }

    // check simCA hoặc Usb token
    if (
      (this.selectedCert.typeCertificate ===
        this.enumSignMethod.SIGN_USB_TOKEN ||
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_SIM_CA ||
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_SERVER ||
        this.selectedCert.typeCertificate === this.enumSignMethod.CLOUD_CA ||
        this.selectedCert.typeCertificate === this.enumSignMethod.VNEID ||
        this.selectedCert.typeCertificate === this.enumSignMethod.EASY_CA) &&
      this.roleApprover != "2"
    ) {
      if(!this.creatorSide){
      if (this.checkCertNumber) {
        if (
          this.selectedCert.taxCode.length > 0 &&
          (this.selectedCert.taxCode.toUpperCase() ===
            this.validateCertificateSign.certificateNo.toUpperCase() ||
            (this.validateCertificateSign.representDocumentNumber &&
              this.selectedCert.taxCode.toUpperCase() ===
                this.validateCertificateSign.representDocumentNumber.toUpperCase()) ||
            (this.validateCertificateSign.taxCode &&
              this.selectedCert.taxCode.toUpperCase() ===
                this.validateCertificateSign.taxCode.toUpperCase()))
        ) {
        } else {
          this.toastr.error(
            this.message.getMessage(
              "messages.digital_certificate_validate_taxCode"
            )
          );
          return false;
        }
      
      }
    

      // check name
      if (this.checkName) {
        const enterpriseName = localStorage.getItem("enterpriseNameProcessing");
        if (
          enterpriseName &&
          this.selectedCert.issuedTo.toUpperCase() !==
            enterpriseName.toUpperCase()
        ) {
          this.toastr.error(
            this.message.getMessage(
              "messages.digital_certificate_validate_name"
            )
          );
          return false;
        }
      }
      }
    }

    // check OTP
    if (this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP) {
      if (this.checkOtp) {
        const enterprisePhone =
          this.digitalCertificateService.formatPhoneNumber(
            localStorage.getItem("enterprisePhoneProcessing")
          );
        if (
          enterprisePhone &&
          this.selectedCert.phoneNumber !== enterprisePhone
        ) {
          const message = this.commonService.format(
            this.message.getMessage(
              "messages.digital_certificate_validate_phone"
            ),
            enterprisePhone
          );
          this.toastr.error(message);
          return false;
        }
      }
    }

    let isPassEkyc = false;
    let typeSupportEKYC =
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP ||
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_NO_CERT;
    let isSignEkyc =
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_EKYC ||
      this.selectedCert.typeCertificate ===
        this.enumSignMethod.SIGN_EKYC_ADVANCED;
    if (typeSupportEKYC) {
      if (
        this.supportEkyc &&
        +this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL
      ) {
        if (
          +this.enterpriseInfo.representativeCertificateId ===
            this.certificateTypeID.CCCD ||
          +this.enterpriseInfo.representativeCertificateId ===
            this.certificateTypeID.CMTND ||
          +this.enterpriseInfo.representativeCertificateId ===
            this.certificateTypeID.HO_CHIEU
        ) {
          this.isShowEKYC = true;
          isPassEkyc = await this.getQuantityEkycBeforeNext()
            .toPromise()
            .then();
        } else this.isShowEKYC = false;
      } else this.isShowEKYC = false;
    } else {
      if (isSignEkyc) {
        if (+this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL) {
          if (
            +this.enterpriseInfo.representativeCertificateId ===
              this.certificateTypeID.CCCD ||
            +this.enterpriseInfo.representativeCertificateId ===
              this.certificateTypeID.CMTND ||
            +this.enterpriseInfo.representativeCertificateId ===
              this.certificateTypeID.HO_CHIEU
          ) {
            this.isShowEKYC = true;
            isPassEkyc = await this.getQuantityEkycBeforeNext()
              .toPromise()
              .then();
          } else this.isShowEKYC = false;
        } else this.isShowEKYC = false;
      } else this.isShowEKYC = false;
    }

    // ----------------------- Validate Ảnh ký ------------------------
    // check xem đã đặt chữ ký hay chưa
    if (this.isSelectedPosition.getValue() && this.isShowImage) {
      this.toastr.error(
        this.message.getMessage("messages.need_choose_position")
      );
      this.blockUI.stop();
      return;
    }

    // kiem tra file da ky day du chua
    if (
      this.document.mainContractAttachments &&
      this.document.mainContractAttachments.length &&
      this.isShowImage
    ) {
      const fileName = [];
      let indexError = null;
      let filePathError = null;
      const fileError = [];
      this.document.mainContractAttachments.forEach((ca, index) => {
        const fileId = this.decodeId(ca.id);
        // xoa digital khi ki co image
        const hasImage = this.signPosition.some(
          (e) => e.signType === SignPositionTypes.IMAGE
        );
        const sign = this.signPosition.filter((signData) => {
          if (signData.fileId === fileId) {
            if (hasImage) {
              if (signData.signType !== SignPositionTypes.DIGITAL) {
                return signData;
              }
            } else {
              return signData;
            }
          }
        });
        if (!sign.length) {
          if (!indexError) {
            indexError = index;
            filePathError = ca.path;
          }
          fileError.push(ca.id);
          fileName.push(`'${ca.fileName}'`);
        }
      });
      if (fileName.length) {
        this.changeFile(filePathError, indexError);
        this.fileError = fileError;
        this.toastr.error(
          this.commonService
            .format(
              this.message.getMessage("messages.need_create_sign_file"),
              fileName.join(", ")
            )
            .replace(/&quot;/g, "'")
        );
        this.blockUI.stop();
        return;
      }
    }

    // check EKYC
    if (this.isShowEKYC && !isPassEkyc) {
      this.toastr.error(
        this.message.getMessage(
          "digital_certificate_management.quantity_ekyc_not_enough"
        )
      );
      return;
    }

    if (this.isShowEKYC && isPassEkyc) {
      if (this.ekyc.errors.length > 0) {
        this.toastr.error(this.message.getMessage("kyc.camera_errors"));
        return;
      }
    }

    if (this.isShowEKYC && isPassEkyc && !this.ekyc.errors.length) {
      this.openDialogSignEKYC(tmpl);
      return;
    } else {
      this.signFlowDocument();
    }
  }

  async signFlowDocument() {
    if (this.saveImageData.length == 0) {
      this.saveImageData = _.cloneDeep(this.imageData);
    } else {
      this.imageData = this.saveImageData;
    }

    this.sign = {
      contractId: this.contractId,
      digitalCertificateId: this.selectedCert.id,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      ...this.selectedCert,
    };
    let preImageSort = [];

    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      const hasImage = this.imageData.some(
        (e) => e.signType === SignPositionTypes.IMAGE
      );
      const imageData = this.imageData.filter((signDataImage) => {
        if (signDataImage.fileId === fileId) {
          if (hasImage) {
            if (signDataImage.signType !== SignPositionTypes.DIGITAL) {
              return signDataImage;
            }
          } else {
            return signDataImage;
          }
        }
      });
      preImageSort = preImageSort.concat(imageData);
    }
    const imageSort = _.cloneDeep(preImageSort);
    let imageData = [];
    const arr1 = [];
    for (let i = 0; i < imageSort.length; i++) {
      for (let j = 0; j < imageSort.length; j++) {
        if (
          i !== j &&
          imageSort[j].positionX == imageSort[i].positionX &&
          imageSort[j].positionY == imageSort[i].positionY &&
          imageSort[j].pageNumber == imageSort[i].pageNumber &&
          imageSort[j].widthRectangle == imageSort[i].widthRectangle &&
          imageSort[j].heightRectangle == imageSort[i].heightRectangle &&
          imageSort[j].zoom == imageSort[i].zoom &&
          imageSort[j].fileId == imageSort[i].fileId &&
          imageSort[j].signType !== imageSort[i].signType
        ) {
          if (imageSort[j].signType == "image") {
            arr1.push(imageSort[j]);
          } else {
            arr1.push(imageSort[i]);
          }
          imageSort.splice(j, 1);
          imageSort.splice(i, 1);
          i--;
          break;
        }
      }
    }
    imageData = [...imageSort, ...arr1];
    let imagePreSort = [];
    const mapFileCodes = FileUtils.getCodeOfFileWhenSignOnce(
      this.document.mainContractAttachments
    );
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      if (!this.isShowImage) {
        let imageList = [
          {
            positionX: 1,
            positionY: 1,
            pageNumber: 1,
            signType: "image",
            widthRectangle: 0,
            heightRectangle: 0,
            zoom: 1,
            fileId: fileId,
          },
        ];
        imagePreSort = imagePreSort.concat(imageList);
      } else {
        let imageList = imageData.filter((item) => {
          return item.fileId === fileId;
        });
        imageList = imageList.sort((a, b) =>
          a.pageNumber === b.pageNumber
            ? Number(b.positionY) - Number(a.positionY)
            : Number(a.pageNumber) - Number(b.pageNumber)
        );
        imagePreSort = imagePreSort.concat(imageList);
      }
    }
    this.signImages = imagePreSort.map((item) => {
      item["code"] = mapFileCodes.get(item.fileId);
      return item;
    });
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    if (this.isShowEKYC) {
      this.onIdentityEKYC();
    } else if (
      this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP
    ) {
      if (!this.isShowEKYC) {
        this.processSignOTP();
      }
    } else {
      this.blockUI.reset();
      this.blockUI.start("");
      // tạo cái ảnh ký trước, nếu tạo ảnh ký lỗi thì nghỉ không ký
      if (this.systemImageSign && this.fileUpload) {
        const date = await this.signDocumentService.getDateAsync().toPromise();
        const email = await this.signDocumentService
          .getEmailAsync()
          .toPromise();

        this.signConfig.signingTime.value = date.data.date;
        this.signConfig.email.value = email.data;
        // cert đã cấu hình (type 0) -> gen theo defaultSignConfig của chứng thư; chưa cấu hình (null) -> giữ user-config
        this.imageGenerateService.applyCertDefaultSignConfig(this.signConfig, this.selectedCert);
        let blob = null;
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService
            .genImage(this.signConfig, imageSize)
            .toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService
              .genImage(this.signConfig, imageSize)
              .toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
          }
        }

        if (!blob) {
          this.toastr.error(
            this.message.getMessage("messages.error_proccessing")
          );
          this.blockUI.stop();
          return;
        }

        const file = new File([blob], "lastImage.png", { type: "image/png" });
        this.fileUpload = file;
      }

      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_SERVER
      ) {
        this.digitalCertificateService
          .getPermissionHSM(localStorage.getItem("enterpriseId"))
          .subscribe((res) => {
            if (res.data.enableHsm) {
              if (
                this.document.isConfirmBCT &&
                this.selectedCert.typeCertificate !==
                  this.enumSignMethod.SIGN_USB_TOKEN
              ) {
                let body = {};
                if (this.roleApprover == "2") {
                  this.signImages.forEach((rs) => {
                    rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
                  });
                  body = {
                    signMethod: this.selectedCert.typeCertificate,
                    contractId: this.contractId,
                    signPositions: this.signImages,
                  };
                } else {
                  body = {
                    signMethod: this.selectedCert.typeCertificate,
                    contractId: this.contractId,
                    signPositions: this.signImages,
                  };
                }
                this.documentService
                  .createTimestampMoney(body)
                  .subscribe((res) => {
                    this.blockUI.stop();
                    if (res && !res.success) {
                      if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                        this.openDialogOutOfMoneyOtp(
                          this.message.getMessage(
                            "digital_certificate_management.out_of_money_timestamp"
                          )
                        );
                      else this.toastr.error(res.message);
                    } else {
                      this.signTransactionId = res.data;
                      this.onClickSignButton();
                    }
                  });
              } else {
                this.blockUI.reset();
                this.blockUI.start("");
                if (this.document.isConfirmBCT) {
                  let body = {};
                  if (this.roleApprover == "2") {
                    this.signImages.forEach((rs) => {
                      rs.isSignDigitalCertificate =
                        this.isSignDigitalCertificate;
                    });
                    body = {
                      signMethod: this.selectedCert.typeCertificate,
                      contractId: this.contractId,
                      signPositions: this.signImages,
                    };
                  } else {
                    body = {
                      signMethod: this.selectedCert.typeCertificate,
                      contractId: this.contractId,
                      signPositions: this.signImages,
                    };
                  }
                  this.documentService
                    .createTimestampMoney(body)
                    .subscribe((res) => {
                      this.blockUI.stop();
                      if (res && !res.success) {
                        if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                          this.openDialogOutOfMoneyOtp(
                            this.message.getMessage(
                              "digital_certificate_management.out_of_money_timestamp"
                            )
                          );
                        else this.toastr.error(res.message);
                      } else {
                        this.signTransactionId = res.data;
                        this.onClickSignButton();
                      }
                    });
                } else {
                  this.signImages = imagePreSort;
                  this.blockUI.stop();
                  this.onClickSignButton();
                }
              }
            } else {
              this.toastr.error(
                this.message.getMessage("messages.not_hsm_permission")
              );
            }
          });
      } else {
        if (
          this.document.isConfirmBCT &&
          this.selectedCert.typeCertificate !==
            this.enumSignMethod.SIGN_USB_TOKEN
        ) {
          let body = {};
          if (this.roleApprover == "2") {
            this.signImages.forEach((rs) => {
              rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
            });
            body = {
              signMethod: this.selectedCert.typeCertificate,
              contractId: this.contractId,
              signPositions: this.signImages,
            };
          } else {
            body = {
              signMethod: this.selectedCert.typeCertificate,
              contractId: this.contractId,
              signPositions: this.signImages,
            };
          }
          this.documentService.createTimestampMoney(body).subscribe((res) => {
            this.blockUI.stop();
            if (res && !res.success) {
              if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                this.openDialogOutOfMoneyOtp(
                  this.message.getMessage(
                    "digital_certificate_management.out_of_money_timestamp"
                  )
                );
              else this.toastr.error(res.message);
            } else {
              this.signTransactionId = res.data;
              this.onClickSignButton();
            }
          });
        } else {
          this.blockUI.reset();
          this.blockUI.start("");
          if (this.document.isConfirmBCT) {
            let body = {};
            if (this.roleApprover == "2") {
              this.signImages.forEach((rs) => {
                rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
              });
              body = {
                signMethod: this.selectedCert.typeCertificate,
                contractId: this.contractId,
                signPositions: this.signImages,
              };
            } else {
              body = {
                signMethod: this.selectedCert.typeCertificate,
                contractId: this.contractId,
                signPositions: this.signImages,
              };
            }

            this.documentService.createTimestampMoney(body).subscribe((res) => {
              this.blockUI.stop();
              if (res && !res.success) {
                if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                  this.openDialogOutOfMoneyOtp(
                    this.message.getMessage(
                      "digital_certificate_management.out_of_money_timestamp"
                    )
                  );
                else this.toastr.error(res.message);
              } else {
                this.signTransactionId = res.data;
                this.onClickSignButton();
              }
            });
          } else {
            this.signImages = imagePreSort;
            this.blockUI.stop();
            this.onClickSignButton();
          }
        }
      }
    }
  }

  openDialogSignEKYC(tmpl: TemplateRef<any>) {
    this.templateRefEKYC = tmpl;
    this.dialog.open(tmpl, {
      width: "80%",
      panelClass: "ekyc-dialog",
    });
  }

  onCloseDialog() {
    this.dialog.closeAll();
  }

  async processSignOTP() {
    this.sign = {
      contractId: this.contractId,
      digitalCertificateId: this.selectedCert.id,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      ...this.selectedCert,
    };
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages,
    };

    // tạo lại ảnh ký với giờ hiện tại, nếu lỗi thì không cho ký
    if (this.systemImageSign && this.fileUpload) {
      const date = await this.signDocumentService.getDateAsync().toPromise();
      const email = await this.signDocumentService.getEmailAsync().toPromise();

      this.signConfig.signingTime.value = date.data.date;
      this.signConfig.email.value = email.data;
      // cert đã cấu hình (type 0) -> gen theo defaultSignConfig của chứng thư; chưa cấu hình (null) -> giữ user-config
      this.imageGenerateService.applyCertDefaultSignConfig(this.signConfig, this.selectedCert);
      let blob = null;
      try {
        let imageSize = this.setSizeFrameImage();
        blob = await this.imageGenerateService
          .genImage(this.signConfig, imageSize)
          .toPromise();
      } catch (e) {
        console.log("call api error, use html to image", e);
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService
            .genImage(this.signConfig, imageSize)
            .toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
        }
      }

      if (!blob) {
        this.toastr.error(
          this.message.getMessage("messages.error_proccessing")
        );
        return;
      }

      const file = new File([blob], "lastImage.png", { type: "image/png" });
      this.fileUpload = file;
    }

    this.signDocumentService
      .generateTransaction(
        this.sign.contractId,
        this.selectedCert.phoneNumber,
        request
      )
      .subscribe((rs) => {
        if (!rs.success) {
          if (rs.code === ErrorCode.OutOfMoneyOtp) {
            this.toastr.error(
              this.message.getMessage("messages.otp_out_of_money")
            );
          } else {
            this.toastr.error(rs.message);
          }
        } else {
          this.openDialogConfirmSignOTP(rs.data);
        }
      });
  }

  async processSignNoCertificate() {
    this.dialogRef = this.dialog.open(SigningDialogComponent, {
      width: "80%",
      disableClose: true,
      data: this,
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.signProcessing = [];
      this.errorStatus = null;
      this.signError = null;
      this.isCancel = false;
      this.isCallDone = false;
      this.processingId = null;
      this.dialog.closeAll();
    });
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = JSON.stringify(img);
      const file = this.document.mainContractAttachments.find(
        (ca) => this.decodeId(ca.id) === img.fileId
      );
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : "";
      sign.image = this.fileUpload;
      // const res = await api.toPromise().catch(err => {
      //   this.errorStatus = this.message.getMessage('messages.sign_fail');
      // });
      let res;

      if (this.systemImageSign && this.fileUpload) {
        // không gọi api lấy date nữa vì gọi trước rồi
        sign.image = this.fileUpload;

        res = await this.signDocumentService
          .signWithImageNoCertificate(sign)
          .toPromise()
          .catch((err) => {
            this.errorStatus = this.message.getMessage("messages.sign_fail");
          });

        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        } else if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(
            (ca) => ca.id === file.id
          );
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      } else {
        res = await this.signDocumentService
          .signWithImageNoCertificate(sign)
          .toPromise()
          .catch((err) => {
            this.errorStatus = this.message.getMessage("messages.sign_fail");
          });

        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        }
        if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(
            (ca) => ca.id === file.id
          );
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_NO_CERT_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_NO_CERT_EKYC_ADVANCED;
      }
    }
    const data = {
      signMethod,
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      message: this.noteControl.value,
    };
    if (isSuccess) {
      this.isCallDone = true;
      this.signDocumentService.signDone(data).subscribe(
        (res) => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
        (err) => {
          this.errorStatus = this.message.getMessage("messages.sign_fail");
        }
      );
    } else {
      this.errorStatus = "messages.stop_sign_document";
      this.signDocumentService.signCancel(data).subscribe((res) => {});
    }
  }

  async onClickSignButton() {
    if (this.document.isConfirmBCT) {
      this.signImages = this.signImages.map((item) => {
        item["signTransactionId"] = this.signTransactionId;
        return item;
      });
    }
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    setTimeout(() => {
      if (
        this.selectedCert.typeCertificate !== this.enumSignMethod.SIGN_OTP &&
        this.selectedCert.typeCertificate !== this.enumSignMethod.SIGN_NO_CERT
      ) {
        this.dialogRef = this.dialog.open(SigningDialogComponent, {
          width: "80%",
          disableClose: true,
          data: this,
        });
        this.dialogRef.afterClosed().subscribe(() => {
          this.signProcessing = [];
          this.errorStatus = null;
          this.signError = null;
          this.isCancel = false;
          this.isCallDone = false;
          this.processingId = null;
          this.dialog.closeAll();
        });
      }
    }, 0);

    if (this.fileUpload) {
      this.sign = {
        ...this.sign,
        image: this.fileUpload,
      };
    }

    if (!this.isShowImage) {
      fetch("../../../../../../../assets/images/arrowLeft.png")
        .then((response) => response.blob())
        .then((blob) => {
          this.fileUpload = new File([blob], "fileNameGoesHere", {
            type: "image/png",
          });
          if (this.fileUpload) {
            this.onClickConfirmButtonImage();
          }
        })
        .catch((error) => {
          console.error("Lỗi khi đọc tệp ảnh", error);
        });
    } else {
      if (!this.fileUpload) {
        this.onClickConfirmButton();
      } else {
        this.onClickConfirmButtonImage();
      }
    }
  }

  openDialogOutOfMoneyOtp(message) {
    const confirmDialog = this.dialog.open(NotifyWarningComponent, {
      data: message,
    });
  }

  openDialogConfirmSignOTP(transactionId: string) {
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages,
    };

    const dataCancel = {
      transactionId: transactionId,
      userCancel: true,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: [],
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      phoneNumber: this.selectedCert.phoneNumber,
      serialNumber: this.selectedCert.serialNumber,
    };
    this.dialogRef = this.dialog.open(ConfirmSignOtpWithImageComponent, {
      width: "40%",
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.selectedCert.phoneNumber,
        listSignPosition: this.imageData,
        image: this.fileUpload,
        function: this.processSignOTPAfterDialogClose.bind(this),
        supportEkyc: this.supportEkyc,
        request: request,
        signingInteval: this.signingInteval,
        openSigningDialog: this.openSigningDialog,
        dataCancel: dataCancel,
      },
    });

    this.dialogRef.afterClosed().subscribe((ref) => {
      if (ref) {
        this.dialogRef = this.dialog.open(SigningDialogComponent, {
          width: "80%",
          disableClose: true,
          data: this,
        });
        this.dialogRef.afterClosed().subscribe(() => {
          this.signProcessing = [];
          this.errorStatus = null;
          this.signError = null;
          this.isCancel = false;
          this.isCallDone = false;
          this.processingId = null;
          this.dialog.closeAll();
        });
      }
    });
  }

  async processSignSimCA() {
    this.sign.phoneNumber = this.selectedCert.phoneNumber;
    this.sign.serialNumber = this.selectedCert.serialNumber;
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = img;
      sign.message = this.noteControl.value;
      const file = this.document.mainContractAttachments.find(
        (ca) => this.decodeId(ca.id) === img.fileId
      );
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : "";
      let res;
      if (this.systemImageSign && this.fileUpload) {
        // không gọi lấy lại date nữa vì gọi ở ngoài rồi
        this.fileUpload = file;

        sign.image = this.fileUpload;

        res = await this.signDocumentService
          .signSimCAWithImage(sign)
          .toPromise();
      } else {
        res = await this.signDocumentService
          .signSimCAWithImage(sign)
          .toPromise();
      }

      if (res && !res.success) {
        isSuccess = false;
        if (!this.isCancelSign) {
          this.signError = res && res.message ? res.message : null;
        }
        break;
      }
      if (!res || !res.data) {
        isSuccess = false;
        break;
      } else {
        filePath[img.fileId] = res.data.path;
        const contractAttachment = mainContractAttachmentsNew.find(
          (ca) => ca.id === file.id
        );
        if (!contractAttachment) {
          const contractAttachmentNew = JSON.parse(JSON.stringify(file));
          contractAttachmentNew.path = res.data.path;
          mainContractAttachmentsNew.push(contractAttachmentNew);
        } else {
          contractAttachment.path = res.data.path;
        }
        if (!this.isCancel) {
          img.done = true;
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    const data = {
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      phoneNumber: this.selectedCert.phoneNumber,
      serialNumber: this.selectedCert.serialNumber,
      message: this.noteControl.value,
    };
    if (isSuccess) {
      this.isCallDone = true;
      this.signDocumentService.signDone(data).subscribe(
        (res) => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
        (err) => {
          this.errorStatus = this.message.getMessage("messages.sign_fail");
        }
      );
    } else {
      this.errorStatus = "messages.stop_sign_document";
      this.signDocumentService.signCancel(data).subscribe((res) => {});
    }
  }

  // sign USB
  async createHashSvc(certUserBase64: string) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        if (this.imageData.length || !this.isShowImage) {
          const filePath = {};
          let isSuccess = true;
          const mainContractAttachmentsNew = [];
          for await (let [index, img] of this.signProcessing.entries()) {
            if (this.isCancel) {
              isSuccess = false;
              break;
            }
            const sign = JSON.parse(JSON.stringify(this.sign));
            sign.position = JSON.stringify(img);

            sign.base64Image = await this.fileToBase64(this.fileUpload);
            const file = this.document.mainContractAttachments.find(
              (ca) => this.decodeId(ca.id) === img.fileId
            );
            sign.path = file && file.path ? file.path : null;
            sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : "";
            sign.signPositions = JSON.stringify(sign.signPositions);
            delete sign.image;
            const rs = await this.documentService
              .createHashWithImage(sign)
              .toPromise();
            if (rs && !rs.success) {
              isSuccess = false;
              this.signError = rs && rs.message ? rs.message : null;
              break;
            }
            if (rs && rs.data) {
              filePath[img.fileId] = rs.data.path;
              const contractAttachment = mainContractAttachmentsNew.find(
                (ca) => ca.id === file.id
              );
              if (!contractAttachment) {
                const contractAttachmentNew = JSON.parse(JSON.stringify(file));
                contractAttachmentNew.path = rs.data.path;
                mainContractAttachmentsNew.push(contractAttachmentNew);
              } else {
                contractAttachment.path = rs.data.path;
              }
              delete sign.oldPath;
              sign.path = rs.data.path;
              sign.signPdf = rs.data.signPdf;
              const signature = await signHashNormal(
                this,
                rs.data.hash,
                this.sessionId,
                this.sign.serialNumber
              );
              if (signature) {
                if (index === 0) {
                  this.isCallDone = false;
                }
                sign.position = JSON.parse(sign.position);
                sign.signPositions = this.signImages;
                const resSign = await this.signUsbNormal(signature, sign);
                if (resSign && !resSign.success) {
                  isSuccess = false;
                  this.signError =
                    resSign && resSign.message ? resSign.message : null;
                  break;
                }
                if (!resSign || !resSign.data) {
                  isSuccess = false;
                  break;
                }
                img.done = true;
              } else {
                isSuccess = false;
                break;
              }
            } else {
              isSuccess = false;
              break;
            }
          }
          if (this.isCancel) {
            isSuccess = false;
          }
          const data = {
            signTransactionId: this.signTransactionId,
            userCancel: this.userCancel,
            signMethod: this.selectedCert.typeCertificate,
            contractId: this.document.id,
            mainContractAttachments: mainContractAttachmentsNew,
            certificate: this.sign.certificate,
            digitalCertificateDetailId: this.selectedCert.idDetail,
            message: this.noteControl.value,
          };
          if (isSuccess) {
            this.isCallDone = true;
            this.signDocumentService.signDone(data).subscribe(
              (res) => {
                if (res && res.data) {
                  this.onSignSuccess();
                } else {
                  this.isCallDone = false;
                }
              },
              (err) => {
                this.errorStatus =
                  this.message.getMessage("messages.sign_fail");
              }
            );
          } else {
            this.errorStatus = "messages.stop_sign_document";
            this.signDocumentService.signCancel(data).subscribe((res) => {});
          }
        }
      } else {
        const filePath = {};
        let isSuccess = true;
        const mainContractAttachmentsNew = [];
        for await (let [index, img] of this.signProcessing.entries()) {
          if (this.isCancel) {
            isSuccess = false;
            break;
          }
          const sign = JSON.parse(JSON.stringify(this.sign));
          sign.position = img;

          const file = this.document.mainContractAttachments.find(
            (ca) => this.decodeId(ca.id) === img.fileId
          );
          sign.path = file && file.path ? file.path : null;
          sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : "";
          const rs = await this.documentService
            .createHashNoImage(sign)
            .toPromise();
          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
            break;
          }
          if (rs && rs.data) {
            filePath[img.fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(
              (ca) => ca.id === file.id
            );
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            delete sign.oldPath;
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            const signature = await signHashNormal(
              this,
              rs.data.hash,
              this.sessionId,
              this.sign.serialNumber
            );
            if (signature) {
              if (index === 0) {
                this.isCallDone = false;
              }
              sign.signPositions = this.signImages;
              const resSign = await this.signUsbNormal(signature, sign);
              if (resSign && !resSign.success) {
                isSuccess = false;
                this.signError =
                  resSign && resSign.message ? resSign.message : null;
                break;
              }
              if (!resSign || !resSign.data) {
                isSuccess = false;
                break;
              }
              img.done = true;
            } else {
              isSuccess = false;
              break;
            }
          } else {
            isSuccess = false;
            break;
          }
        }
        if (this.isCancel) {
          isSuccess = false;
        }
        const data = {
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          digitalCertificateDetailId: this.selectedCert.idDetail,
          message: this.noteControl.value,
        };
        if (isSuccess) {
          this.isCallDone = true;
          this.signDocumentService.signDone(data).subscribe(
            (res) => {
              if (res && res.data) {
                this.onSignSuccess();
              } else {
                this.isCallDone = false;
              }
            },
            (err) => {
              this.errorStatus = this.message.getMessage("messages.sign_fail");
            }
          );
        } else {
          this.errorStatus = "messages.stop_sign_document";
          this.signDocumentService.signCancel(data).subscribe((res) => {});
        }
      }
    }
  }

  async createHash(certUserBase64: string) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        if (this.imageData.length || !this.isShowImage) {
          const filePath = {};
          let isSuccess = true;
          const mainContractAttachmentsNew = [];
          const fileArr = new Set(this.signProcessing.map(($) => $.fileId));
          for await (let [idx, fileId] of fileArr.entries()) {
            if (this.isCancel) {
              isSuccess = false;
              break;
            }
            const sign = JSON.parse(JSON.stringify(this.sign));
            const _dst$ = this.signProcessing.filter(($) => $.fileId == fileId);
            sign.position = JSON.stringify(_dst$[0]);
            sign.signPositions = _dst$;

            sign.base64Image = await this.fileToBase64(this.fileUpload);
            const file = this.document.mainContractAttachments.find(
              (ca) => this.decodeId(ca.id) === fileId
            );
            sign.path = file && file.path ? file.path : null;
            sign.oldPath = filePath[fileId] ? filePath[fileId] : "";
            sign.signPositions = JSON.stringify(sign.signPositions);
            delete sign.image;
            const rs = await this.documentService
              .createHashWithImage(sign)
              .toPromise();
            if (rs && !rs.success) {
              isSuccess = false;
              this.signError = rs && rs.message ? rs.message : null;
              break;
            }
            if (rs && rs.data) {
              filePath[fileId] = rs.data.path;
              const contractAttachment = mainContractAttachmentsNew.find(
                (ca) => ca.id === file.id
              );
              if (!contractAttachment) {
                const contractAttachmentNew = JSON.parse(JSON.stringify(file));
                contractAttachmentNew.path = rs.data.path;
                mainContractAttachmentsNew.push(contractAttachmentNew);
              } else {
                contractAttachment.path = rs.data.path;
              }
              delete sign.oldPath;
              sign.path = rs.data.path;
              sign.signPdf = rs.data.signPdf;
              const signature = await signHashNormal(
                this,
                rs.data.hash,
                this.sessionId,
                this.sign.serialNumber
              );
              if (signature) {
                if (idx === 0) {
                  this.isCallDone = false;
                }
                sign.position = JSON.parse(sign.position);
                sign.signPositions = this.signImages;
                const resSign = await this.signUsbNormal(signature, sign);
                if (resSign && !resSign.success) {
                  isSuccess = false;
                  this.signError =
                    resSign && resSign.message ? resSign.message : null;
                  break;
                }
                if (!resSign || !resSign.data) {
                  isSuccess = false;
                  break;
                }
                _dst$.forEach(($) => ($.done = true));
              } else {
                isSuccess = false;
                break;
              }
            } else {
              isSuccess = false;
              break;
            }
          }
          if (this.isCancel) {
            isSuccess = false;
          }
          const data = {
            signTransactionId: this.signTransactionId,
            userCancel: this.userCancel,
            signMethod: this.selectedCert.typeCertificate,
            contractId: this.document.id,
            mainContractAttachments: mainContractAttachmentsNew,
            certificate: this.sign.certificate,
            digitalCertificateDetailId: this.selectedCert.idDetail,
            message: this.noteControl.value,
          };
          if (isSuccess) {
            this.isCallDone = true;
            this.signDocumentService.signDone(data).subscribe(
              (res) => {
                if (res && res.data) {
                  this.onSignSuccess();
                } else {
                  this.isCallDone = false;
                }
              },
              (err) => {
                this.errorStatus =
                  this.message.getMessage("messages.sign_fail");
              }
            );
          } else {
            this.errorStatus = "messages.stop_sign_document";
            this.signDocumentService.signCancel(data).subscribe((res) => {});
          }
        }
      } else {
        const filePath = {};
        let isSuccess = true;
        const mainContractAttachmentsNew = [];
        if (this.signProcessing && this.signProcessing.length > 0) {
          const fileArr = new Set(this.signProcessing.map(($) => $.gileId));
          for await (const [idx, fileId] of fileArr.entries()) {
            if (this.isCancel) {
              isSuccess = false;
              break;
            }
            const sign = JSON.parse(JSON.stringify(this.sign));
            const _dst$ = this.signProcessing.filter(($) => $.fileId == fileId);
            sign.position = _dst$[0];
            sign.signPositions = _dst$;

            const file = this.document.mainContractAttachments.find(
              (ca) => this.decodeId(ca.id) === fileId
            );
            sign.path = file && file.path ? file.path : null;
            sign.oldPath = filePath[fileId] ? filePath[fileId] : "";
            const rs = await this.documentService
              .createHashNoImage(sign)
              .toPromise();
            if (rs && !rs.success) {
              isSuccess = false;
              this.signError = rs && rs.message ? rs.message : null;
              break;
            }
            if (rs && rs.data) {
              filePath[fileId] = rs.data.path;
              const contractAttachment = mainContractAttachmentsNew.find(
                (ca) => ca.id === file.id
              );
              if (!contractAttachment) {
                const contractAttachmentNew = JSON.parse(JSON.stringify(file));
                contractAttachmentNew.path = rs.data.path;
                mainContractAttachmentsNew.push(contractAttachmentNew);
              } else {
                contractAttachment.path = rs.data.path;
              }
              delete sign.oldPath;
              sign.path = rs.data.path;
              sign.signPdf = rs.data.signPdf;
              const signature = await signHashNormal(
                this,
                rs.data.hash,
                this.sessionId,
                this.sign.serialNumber
              );
              if (signature) {
                if (idx === 0) {
                  this.isCallDone = false;
                }
                sign.signPositions = this.signImages;
                const resSign = await this.signUsbNormal(signature, sign);
                if (resSign && !resSign.success) {
                  isSuccess = false;
                  this.signError =
                    resSign && resSign.message ? resSign.message : null;
                  break;
                }
                if (!resSign || !resSign.data) {
                  isSuccess = false;
                  break;
                }
                _dst$.forEach(($) => ($.done = true));
              } else {
                isSuccess = false;
                break;
              }
            } else {
              isSuccess = false;
              break;
            }
          }
        }

        if (this.isCancel) {
          isSuccess = false;
        }
        const data = {
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          digitalCertificateDetailId: this.selectedCert.idDetail,
          message: this.noteControl.value,
        };
        if (isSuccess) {
          this.isCallDone = true;
          this.signDocumentService.signDone(data).subscribe(
            (res) => {
              if (res && res.data) {
                this.onSignSuccess();
              } else {
                this.isCallDone = false;
              }
            },
            (err) => {
              this.errorStatus = this.message.getMessage("messages.sign_fail");
            }
          );
        } else {
          this.errorStatus = "messages.stop_sign_document";
          this.signDocumentService.signCancel(data).subscribe((res) => {});
        }
      }
    }
  }

  createHashWorker(
    certUserBase64: string,
    hSession: string,
    serialNumber: string
  ) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        this.fileToBase64(this.fileUpload).then(base64 => {
          const body = { ...this.sign, base64Image: base64 };
          body.signPositions = JSON.stringify(body.signPositions);
          delete body.image;
          this.documentService
            .createHashWithImage(body)
            .subscribe(async (rs) => {
              this.sign.path = rs.data.path;
              this.sign.signPdf = rs.data.signPdf;
              this.subscribeHash.next(rs.data.hash);
            });
        });
      } else {
        this.documentService
          .createHashNoImage(this.sign)
          .subscribe(async (rs) => {
            this.sign.path = rs.data.path;
            this.sign.signPdf = rs.data.signPdf;
            this.subscribeHash.next(rs.data.hash);
          });
      }
    }
  }

  async signUsbNormal(signature: string, sign: any) {
    sign.signature = signature;
    const res = await this.signUsb(sign);
    return res;
  }

  async signUsb(certificate: any) {
    const res = await this.documentService.signUsb(certificate).toPromise();
    return res;
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve((reader.result as string).split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  setSerialNumber(value) {
    this.sign.serialNumber = value;
  }

  setIssuedTo(value) {
    this.sign.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.sign.distinguishedName = value;
  }

  setTaxCode(value) {
    this.sign.taxCode = value;
  }

  setIssuedBy(value) {
    this.sign.issuedBy = value;
  }

  setCertRawdata(value) {
    this.sign.certRawdata = value;
  }

  setActiveDate(value) {
    this.sign.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.sign.expireDate = new Date(value);
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  // end sign usb

  onClickConfirmButtonImage() {
    setTimeout(() => {
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_NO_CERT
      ) {
        if (!this.isShowEKYC) {
          this.processSignNoCertificate();
        }
      } else {
        switch (this.selectedCert.typeCertificate) {
          case this.enumSignMethod.SIGN_SERVER:
            this.processSignServerImage();
            break;
          case this.enumSignMethod.SIGN_USB_TOKEN:
            // this.blockUI.start('');
            this.isCallDone = true;
            initPluginCertificateNormal(this, null);
            break;
          case this.enumSignMethod.SIGN_SIM_CA:
            this.processSignSimCAImage();
            break;
          case this.selectedCert.typeCertificate ===
            this.enumSignMethod.SIGN_HSM:
            this.processSignHSM();
            break;
          case EnumSignMethod.CLOUD_CA:
            this.isCallDone = false;
            this.processSignCloudCA();
            break;
          case EnumSignMethod.EASY_CA:
            this.isCallDone = false;
            this.processSignEasyCA();
            break;
          case EnumSignMethod.VNEID:
            this.isCallDone = false;
            this.processSignVNeID();
            break;
          default:
            break;
        }
      }
    }, 400);
  }

  onClickConfirmButton() {
    setTimeout(() => {
      if (
        this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_NO_CERT
      ) {
        if (!this.isShowEKYC) {
          this.processSignNoCertificate();
        }
      } else {
        switch (this.selectedCert.typeCertificate) {
          case this.enumSignMethod.SIGN_SERVER:
            this.processSignServerNoImage();
            break;
          case this.enumSignMethod.SIGN_USB_TOKEN:
            this.isCallDone = true;
            initPluginCertificateNormal(this, null);
            break;
          case this.enumSignMethod.SIGN_SIM_CA:
            this.processSignSimCANoImage();
            break;
          case this.enumSignMethod.SIGN_OTP:
            if (!this.isShowEKYC) {
              this.processSignOTP();
            }
            break;
          case this.enumSignMethod.SIGN_HSM:
            this.processSignHSM();
            break;
          case EnumSignMethod.CLOUD_CA:
            this.isCallDone = false;
            this.processSignCloudCA();
            break;
          case EnumSignMethod.EASY_CA:
            this.isCallDone = false;
            // this.processSignEasyCA();
            break;
          case EnumSignMethod.VNEID:
            this.isCallDone = false;
            this.processSignVNeID();
            break;
          default:
            break;
        }
      }
    }, 400);
  }

  async processSignServerImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    sign.message = this.noteControl.value;
    this.getApiSignImageSystem(
      this.signDocumentService.signatureServerImage,
      sign
    );
    this.signingProcess(sign.signTransactionCode);
  }

  async processSignServerNoImage() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = img;
      const file = this.document.mainContractAttachments.find(
        (ca) => this.decodeId(ca.id) === img.fileId
      );
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : "";
      const res = await this.signDocumentService
        .signatureServerNoImage(sign)
        .toPromise()
        .catch((err) => {
          this.errorStatus = this.message.getMessage("messages.sign_fail");
        });
      if (res && !res.success) {
        isSuccess = false;
        this.signError = res && res.message ? res.message : null;
        break;
      }
      if (!res || !res.data) {
        isSuccess = false;
        break;
      } else {
        filePath[img.fileId] = res.data.path;
        const contractAttachment = mainContractAttachmentsNew.find(
          (ca) => ca.id === file.id
        );
        if (!contractAttachment) {
          const contractAttachmentNew = JSON.parse(JSON.stringify(file));
          contractAttachmentNew.path = res.data.path;
          mainContractAttachmentsNew.push(contractAttachmentNew);
        } else {
          contractAttachment.path = res.data.path;
        }
        if (!this.isCancel) {
          img.done = true;
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    const data = {
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      digitalCertificateId: this.selectedCert.id,
      message: this.noteControl.value,
    };
    if (isSuccess) {
      this.isCallDone = true;
      this.signDocumentService.signDone(data).subscribe(
        (res) => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
        (err) => {
          this.errorStatus = this.message.getMessage("messages.sign_fail");
        }
      );
    } else {
      this.errorStatus = "messages.stop_sign_document";
      this.signDocumentService.signCancel(data).subscribe((res) => {});
    }
  }

  async processSignSimCAImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    sign.message = this.noteControl.value;
    this.getApiSignImageSystem(
      this.signDocumentService.signSimCAWithImage,
      sign
    );
    this.signingProcess(sign.signTransactionCode);
  }

  async processSignSimCANoImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = this.signProcessing;
    sign.message = this.noteControl.value;
    this.signDocumentService.signSimCANoImage(sign).subscribe((res) => {});
    this.signingProcess(sign.signTransactionCode);
  }

  async processSignCloudCA() {
    const filePath = {};
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = [];
    for (const item of this.signProcessing) {
      item.index = id;
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item,
        });
      } else {
        hashMap[fileId] = [
          {
            ...item,
          },
        ];
      }
      id++;
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign,
      });
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length;
      }
    }
    // // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < this.signProcessing.length; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];
          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
            signProcessingId: position.index,
          };
          const file = this.document.mainContractAttachments.find(
            (ca) => this.decodeId(ca.id) === dataItem.fileId
          );
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId]
            ? filePath[requestItem.fileId]
            : "";
          signPositions.push(requestItem);
        }
      }
    }
    const newRequest = {
      ...this.sign,
      listSignPosition: signPositions,
      signTransactionCode: this.commonService.generateUUID(),
      message: this.noteControl.value,
    };
    if (this.fileUpload) {
      const imageRequest = {
        ...this.sign,
        image: this.fileUpload,
        signTransactionCode: this.commonService.generateUUID(),
        listSignPosition: JSON.stringify(signPositions),
        message: this.noteControl.value,
      };
      this.getApiSignImageSystem(
        this.signDocumentService.signCloudCAWithImage,
        imageRequest
      );

      this.signingProcess(imageRequest.signTransactionCode);
    } else {
      this.signDocumentService
        .signCloudCANoImage(newRequest)
        .subscribe((res) => {
          if (res.success) {
            this.showPopupSaveTrans = res.data.showPopupSaveTrans;
          }
        });
      this.signingProcess(newRequest.signTransactionCode);
    }
  }
  async processSignVNeID() {
    const filePath = {};
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = [];
    for (const item of this.signProcessing) {
      item.index = id;
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item,
        });
      } else {
        hashMap[fileId] = [
          {
            ...item,
          },
        ];
      }
      id++;
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign,
      });
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length;
      }
    }
    // // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < this.signProcessing.length; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];
          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
            signProcessingId: position.index,
          };
          const file = this.document.mainContractAttachments.find(
            (ca) => this.decodeId(ca.id) === dataItem.fileId
          );
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId]
            ? filePath[requestItem.fileId]
            : "";
          signPositions.push(requestItem);
        }
      }
    }
    const newRequest = {
      ...this.sign,
      listSignPosition: signPositions,
      signTransactionCode: this.commonService.generateUUID(),
      message: this.noteControl.value,
    };
    if (this.fileUpload) {
      const imageRequest = {
        ...this.sign,
        image: this.fileUpload,
        signTransactionCode: this.commonService.generateUUID(),
        listSignPosition: JSON.stringify(signPositions),
        message: this.noteControl.value,
        citizenPid: this.sign.taxCode,
        issuerDN: this.sign.issuedTo
      };
      this.getApiSignImageSystem(
        this.signDocumentService.signVNeIDWithImage,
        imageRequest
      );

      this.signingProcess(this.VNeIDTransactionCode);
    } else {
      this.signDocumentService
        .signVNeIDWithImage(newRequest)
        .subscribe((res) => {
          if(this.typeCertificate == EnumSignMethod.VNEID){
            this.VNeIDTransactionCode = res.data
          }
        });
      this.signingProcess(this.VNeIDTransactionCode);
    }
  }
  async processSignEasyCA() {
    const filePath = {};
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = [];
    for (const item of this.signProcessing) {
      item.index = id;
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item,
        });
      } else {
        hashMap[fileId] = [
          {
            ...item,
          },
        ];
      }
      id++;
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign,
      });
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length;
      }
    }
    // // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < this.signProcessing.length; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];
          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
            signProcessingId: position.index,
          };
          const file = this.document.mainContractAttachments.find(
            (ca) => this.decodeId(ca.id) === dataItem.fileId
          );
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId]
            ? filePath[requestItem.fileId]
            : "";
          signPositions.push(requestItem);
        }
      }
    }
    if (this.fileUpload) {
      const imageRequest = {
        ...this.sign,
        image: this.fileUpload,
        signTransactionCode: this.commonService.generateUUID(),
        listSignPosition: JSON.stringify(signPositions),
        message: this.noteControl.value,
        serial: this.sign.serialNumber,
      };
      this.getApiSignImageSystem(
        this.signDocumentService.signEasyCAWithImage,
        imageRequest
      );

      this.signingProcess(imageRequest.signTransactionCode);
    }
  }
  showPopupSaveTrans: boolean = false;
  async processSignHSM() {
    let isSuccess = true;
    for await (const img of this.signProcessing) {
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = img;
      if (this.fileUpload) {
        sign.image = this.fileUpload;
      }
      if (this.isCancel) {
        isSuccess = false;
        break;
      }

      this.getApiSignImageSystem(this.signDocumentService.signHSM, sign);
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
    }
  }

  getApiSignImageSystem(api: any, body) {
    // không phải gọi api lấy lại date nữa, gọi bên từ trước rồi
    if (this.systemImageSign && this.fileUpload) {
      setTimeout(async () => {
        body.image = this.fileUpload;
        api(body).subscribe(
          (res) => {
            if (res.success)
              this.showPopupSaveTrans = res.data.showPopupSaveTrans
                ? res.data.showPopupSaveTrans
                : false;
              if(this.typeCertificate === EnumSignMethod.VNEID){
                this.VNeIDTransactionCode = res.data
              }
          },
          () => {
            this.errorStatus = this.message.getMessage("messages.sign_fail");
          }
        );
      }, 300);
    } else {
      api(body).subscribe(
        (res) => {
          if (res.success)
            this.showPopupSaveTrans = res.data.showPopupSaveTrans
              ? res.data.showPopupSaveTrans
              : false;
            if(this.typeCertificate === EnumSignMethod.VNEID){
              this.VNeIDTransactionCode = res.data
            }
        },
        () => {
          this.errorStatus = this.message.getMessage("messages.sign_fail");
        }
      );
    }
  }

  // Hàm xử lý lấy kết quả phiên ký liên tục mỗi 2s
  signingProcess(signTransactionCode, dialog?: any, focusInput?: any) {
    setTimeout(() => {
      this.signingInteval = setInterval(() => {
        if(this.typeCertificate == EnumSignMethod.VNEID){
          signTransactionCode = this.VNeIDTransactionCode
        }
        this.signDocumentService
          .getStatusSign({ signTransactionCode: signTransactionCode })
          .subscribe((rs) => {
            if (
              rs &&
              rs.success &&
              rs.data &&
              (rs.data.status == "DONE" ||
                rs.data.status == "DAEMON_PROCESSING")
            ) {
              this.isCallDone = true;
              this.signDocumentService.openSigningDialog.next(true);
              clearInterval(this.signingInteval);
              this.onSignSuccess();
            } else if (
              rs &&
              rs.success &&
              rs.data &&
              rs.data.status !== "ERROR"
            ) {
              let arrayStatus = {};
              if (
                !this.openSigningDialog &&
                this.selectedCert.typeCertificate ===
                  this.enumSignMethod.SIGN_OTP &&
                rs.data.list[0].status == "DONE"
              ) {
                this.blockUI.stop();
                this.signDocumentService.openSigningDialog.next(true);
                dialog.close(true);
              }
              for (let i = 0; i < rs.data.list.length; i++) {
                arrayStatus[rs.data.list[i].code] = rs.data.list[i].status;
              }
              for (let i = 0; i < this.signProcessing.length; i++) {
                this.signProcessing[i].done =
                  arrayStatus[this.signProcessing[i].code] == "DONE" ||
                  arrayStatus[this.signProcessing[i].code] ==
                    "DAEMON_PROCESSING"
                    ? true
                    : false;
              }
            } else if (rs.data && rs.data.status === "ERROR") {
              //dừng xử lý và thông báo lỗi khi ký otp
              if (
                !this.openSigningDialog &&
                this.selectedCert.typeCertificate ===
                  this.enumSignMethod.SIGN_OTP
              ) {
                this.toastr.error(rs.data.message);
                this.blockUI.stop();
                focusInput();
              } else {
                this.signDocumentService.openSigningDialog.next(false);
                this.errorStatus = "messages.stop_sign_document";
                this.signError = rs && rs.data.message ? rs.data.message : null;
              }
              clearInterval(this.signingInteval);
            }
          });
      }, 10000);
    }, 10000);
  }

  async processSignOTPAfterDialogClose(
    signDialog: any,
    dialog: any,
    focusInput: any
  ) {
    this.blockUI.reset();
    this.blockUI.start("");
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.otp = signDialog.otp;
    sign.anonymousOtp = false;
    sign.transactionId = signDialog.transactionId;
    sign.contractId = signDialog.contractId;
    sign.signMethod = signMethod;
    sign.message = this.noteControl.value;
    if (this.fileUpload) {
      sign.signPositions = JSON.stringify(this.signProcessing);
      sign.image = this.fileUpload;
      this.getApiSignImageSystem(
        this.signDocumentService.signOtpWithImage,
        sign
      );
    } else {
      sign.signPositions = this.signProcessing;
      this.signDocumentService
        .signOtpNoImage(sign)
        .toPromise()
        .catch((err) => {
          this.errorStatus = this.message.getMessage("messages.sign_fail");
        });
    }
    this.signingProcess(sign.signTransactionCode, dialog, focusInput);
  }

  resetValue() {
    this.errorStatus = null;
    this.signError = null;
    this.isCancel = false;
    this.isCallDone = false;
  }

  private onSignSuccess() {
    this.dialog.closeAll();
    if (this.isSignDigitalCertificate) {
      this.toastr.success(this.message.getMessage("messages.approve_success"));
    } else {
      this.toastr.success(this.message.getMessage("messages.sign_success"));
    }
    this.success = true;
    this.blockUI.stop();

    if (this.showPopupSaveTrans == true) {
      const param = {
        digitalCertificateId: this.selectedCert.id,
        digitalCertificateDetailId: this.selectedCert.idDetail,
      };
      this.digitalCertificateService
        .getDurationCloudCa(param)
        .subscribe((res) => {
          console.log(res);
          let duration = -1;
          if (res.success) {
            duration = res.data.duration;
          } else {
            this.toastr.error(res.message);
          }
          const dialogRef = this.dialog.open(
            SaveSessionCloudCaDialogApproveComponent,
            {
              width: "600px",
              disableClose: true,
              data: {
                duration: duration,
                name: this.selectedCert.issuedTo,
              },
            }
          );
          dialogRef.afterClosed().subscribe((rs) => {
            if (rs) {
              this.digitalCertificateService
                .saveSessionCloudCa({ ...param, duration: duration })
                .subscribe((res1) => {
                  console.log(res1);
                  if (res1.success) {
                    this.toastr.success(
                      this.message.getMessage(
                        "digital_certificate_management.save_session_cloudca_success"
                      )
                    );
                  } else {
                    this.toastr.error(res1.message);
                  }
                });
            }
            this.backToPrePage();
          });
        });
    } else {
      this.backToPrePage();
    }

    if (this.systemImageSign && this.fileUpload && this.signConfig) {
      this.signDocumentService.postUserConfigAsync(this.signConfig).subscribe();
    }
  }

  checkDisabledBtnSign(): boolean {
    if (this.isShowImage) {
      if (this.isDisableSignBtn) {
        return true;
      }
      if (!this.imageUrlPreview) {
        return true;
      }
      if (!this.certificates.length) {
        return true;
      }
      if (
        this.selectedCert.typeCertificate === 11 &&
        (!this.selectedCert.pin || this.selectedCert.pin.length === 0)
      ) {
        return true;
      }
    } else {
      if (!this.selectedCert.id) {
        return true;
      }
    }
    return false;
  }
  // end fn group sign

  // start fn group userSign Or enterpriseSign
  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if (
      newDataSignConfig.resize === null ||
      newDataSignConfig.resize === undefined
    ) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if (
      newDataSignConfig.showImage === null ||
      newDataSignConfig.showImage === undefined
    ) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }
  // end fn group userSign Or enterpriseSign

  // start mixed fn
  focusoutNoteControl() {
    this.noteControl.patchValue(this.noteControl.value.trim());
  }

  removeNoteControl() {
    this.noteControl.patchValue("");
  }

  setLanguage() {
    this.commonService.getCurrentLanguage().subscribe((lang) => {
      if (lang !== this.language) {
        location.reload();
      }
    });
  }

  processRouteAndBreadcrumbs() {
    this.activeRoute.queryParams.subscribe((params) => {
      this.signPage = params.signPage || 1;
      this.page = params.page || 0;
      this.pageSize = params.pageSize || 0;
      this.routeLink = params.routeLink || null;
      this.enterprise = params.enterprise || null;
      this.documentTypeSearch = params.documentType || null;
      this.nameOrCode = params.nameOrCode || null;
      this.status =
        Common.DOCUMENT_STATUS.indexOf(params.status) === -1
          ? null
          : params.status;
      this.serviceType = params.serviceType || null;
      this.taxCode = params.taxCode || null;
      this.createdUser = params.createdUser || null;
      this.createdTimeFrom = params.createdTimeFrom || null;
      this.createdTimeTo = params.createdTimeTo || null;
      this.finishDateFrom = params.finishDateFrom || null;
      this.finishDateTo = params.finishDateTo || null;
      this.sortColumn = params.sortColumn || null;
      this.sortDirection = params.sortDirection || null;
      this.goFrom = params.goFrom || null;
      this.customerName = params.customerName || "";

      this.documentService.getSignDataValidate().subscribe((validate: any) => {
        this.validateCertificateSign.certificateNo = validate.certificateNo;
        this.validateCertificateSign.representDocumentNumber =
          validate.representDocumentNumber;
        this.validateCertificateSign.taxCode = validate.taxCodeValidate;
      });

      let bread;
      if (this.goFrom === "receive") {
        bread = {
          label: "breadcrumbs.document_search_receive",
          url: "search-document-receive",
          params: [],
        };
        this.routeLink = this.DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK;
      } else if (this.goFrom === "waitSign") {
        bread = {
          label: "breadcrumbs.approved_contract_moha",
          url: "search-document-sign",
          params: [],
        };
        this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK;
      } else if (this.goFrom === "waitSignMoha") {
        bread = {
          label: "breadcrumbs.approved_contract_moha",
          url: "approved-contract-moha",
          params: [],
        };
        this.routeLink = '/home-enterprise/approved-contract-moha';
      } else if (this.goFrom === "waitApprove") {
        bread = {
          label: "breadcrumbs.document_search_approve",
          url: "search-approval-waiting-document",
          params: [],
        };
        this.routeLink = this.APPOVAL_WAIT_ROUTER_ON_BACK_LINK;
      } else if (this.goFrom === "waitInitial") {
        bread = {
          label: "breadcrumbs.document_search_initial",
          url: "search-initial-waiting-document",
          params: [],
        };
        this.routeLink = this.INITIAL_WAIT_ROUTER_ON_BACK_LINK;
      } else if (this.goFrom === "mine") {
        bread = {
          label: "breadcrumbs.document_search_mine",
          url: "search-my-created-document",
          params: [],
        };
        this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
      } else if (this.goFrom === 'negotiate') {
        bread = {
          label: 'negotiate_contract.breadcrumb',
          url: 'search-negotiate-document',
          params: [] };
        this.routeLink = '/home-enterprise/search-negotiate-document'
      } else if (this.goFrom === 'waitSign') {
        bread = {
          label: 'negotiate_contract.breadcrumb',
          url: 'document-approved-contract',
          params: [] };
        this.routeLink = '/home-enterprise/document-approved-contract'
      }else if (this.goFrom === "hdld") {
        bread = {
          label: "breadcrumbs.labor_contract",
          url: "new-document-moha",
          params: [],
        };
        this.routeLink = this.DOCUMENT_MOHA_LINK;
      } else if (this.goFrom === "digitalMyEmployment") {
        bread = {
          label: "breadcrumbs.document_moha",
          url: "digital-contract-employment",
          params: [],
        };
        this.routeLink = this.DOCUMENT_DIGITAL_LINK;
      } 
      else {
        bread = {
          label: "breadcrumbs.document_search",
          url: "search-document",
          params: [],
        };
        this.routeLink = this.DEFAULT_ROUTER_ON_BACK_LINK;
      }

      if (this.isSignDigitalCertificate) {
        this.breadcrumbsService.store([
          { label: "breadcrumbs.home", url: "analysis-report", params: [] },
          { label: "breadcrumbs.document_breadcrumbs", url: "", params: [] },
          bread,
          {
            label: "breadcrumbs.document_approve",
            url: "sign-document/",
            params: [],
          },
        ]);
      } else {
        this.breadcrumbsService.store([
          { label: "breadcrumbs.home", url: "analysis-report", params: [] },
          { label: "breadcrumbs.document_breadcrumbs", url: "", params: [] },
          bread,
          {
            label: "breadcrumbs.document_sign",
            url: "sign-document/",
            params: [],
          },
        ]);
      }
    });

    this.documentService.cancelFlow.subscribe((status) => {
      if (status != null || status != undefined) {
        this.isCancelSign = status;
      }
    });
  }

  checkAccessContract() {
    this.notificationService.subscribeErrorService();

    this.notificationService.getErrorCode().subscribe((errorCode) => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.isCheckAccessToContract = false;
      } else {
        this.isCheckAccessToContract = true;
      }

      if (errorCode === ErrorCode.NotPermissionWithContract) {
        this.backToPrePage();
      }
    });
  }

  checkMethodSign(){
    if(Number(this.userType) === 1){
      this.openMethodSign = true;

    }else{
      if(!this.isEmploymentContract){
        this.openMethodSign = true;
      }
    }
  }

  backToPrePage() {
    this.router.navigate([this.routeLink], {
      queryParams: {
        flagCopy: this.goFrom == 'waitSignMoha' ? false : true,
        page: this.page,
        pageSize: this.pageSize,
        routeLink: this.routeLink,
        enterprise: this.enterprise,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        pageView: true,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      },
    });
  }
  // end mixed fn
  transformContentPositionValue = transformContentPositionValue;
  // ---------------------- END FUNCTION ----------------------

  ngOnDestroy() {
    this.documentService.setImageSignature(null);
    this.canvasService.setCanvasSignatureImageUrl("");
    this.canvasService.setCanvasSignatureImage(null);
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subcribeViewLandscape.unsubscribe();
    this.domRenderImage = null;
    this.fileUpload = null;
    this.systemImageSign = false;
    this.imageUrlPreview = null;
    this.document = null;
    this.pdfSrc = null;
  }

}
